import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import RingLoader from "react-spinners/ScaleLoader";
import FeatherIcon from "feather-icons-react";
//import { TimeField } from "@mui/x-date-pickers/TimeField";
//componentes
import "./nomina.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

function profesionDeLista(valor, lista) {
  const partes = String(valor == null ? "" : valor)
    .split(",")
    .map(function (parte) {
      return parte.trim().toUpperCase();
    })
    .filter(function (parte) {
      return parte !== "";
    });
  for (let i = 0; i < partes.length; i++) {
    if (lista.indexOf(partes[i]) !== -1) {
      return partes[i];
    }
  }
  return "";
}

function sedeGuardadaId(valor) {
  const sede = String(valor == null ? "" : valor).trim();
  if (sede === "" || sede === "0" || sede === "-Seleccione Sucursal-") {
    return "";
  }
  return sede;
}

function aplicarCssEnData(data_, res) {
  const td = String(res && res.variable57 != null ? res.variable57 : "").toUpperCase();
  data_.tipoDocumento = td === "PASAPORTE" ? "PASAPORTE" : "CEDULA";
  data_.dv = String(res && res.variable58 != null ? res.variable58 : "")
    .replace(/\D/g, "")
    .slice(0, 4);
  data_.numeroSso = String(
    res && res.variable59 != null ? res.variable59 : ""
  ).toUpperCase();
}

function esContratoOperativo(tiponomina, tcontrato) {
  const tn = String(tiponomina || "");
  return String(tcontrato || "") === "5" && (tn === "3" || tn === "5" || tn === "6");
}

function codigoOperativo(valor) {
  const v = parseInt(valor, 10) || 0;
  return v >= 1 && v <= 3 ? v : 0;
}

function tienePagoUnicoOperativo(valor) {
  const v = codigoOperativo(valor);
  return v === 1 || v === 3;
}

function tienePorTerapiaOperativo(valor) {
  const v = codigoOperativo(valor);
  return v === 2 || v === 3;
}

function aplicarOperativoEnData(data_, res) {
  const v = codigoOperativo(res && res.variable55 != null ? res.variable55 : 0);
  data_.tcontratoOperativo = v > 0 ? String(v) : "";
}

function codigoOperativoParaGuardar(data) {
  if (!esContratoOperativo(data.tiponomina, data.tcontrato)) {
    return "0";
  }
  const v = codigoOperativo(data.tcontratoOperativo);
  return v > 0 ? String(v) : "0";
}

const CONCEPTOS_VER_MAS = [
  { value: "1", label: "Comisiones" },
  { value: "2", label: "Bonificaciones" },
  { value: "3", label: "Combustible" },
  { value: "4", label: "Dieta" },
  { value: "5", label: "Salario en especie" },
  { value: "6", label: "Viáticos" },
  { value: "7", label: "Gasto de representación" },
  { value: "8", label: "Impuesto sobre renta gasto de representación" },
  { value: "9", label: "Décimo tercer mes gasto de representación" },
  { value: "10", label: "Dividendo" },
  { value: "11", label: "Participación beneficio ingresos" },
  { value: "12", label: "Gratificación / aguinaldo" },
  { value: "13", label: "Preaviso" },
  { value: "14", label: "Indemnización" },
];

const MESES_VER_MAS = [
  "",
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

function periodoVerMasActual() {
  const hoy = new Date();
  const dia = hoy.getDate();
  const mes = hoy.getMonth() + 1;
  const anio = hoy.getFullYear();
  return {
    quincena: dia < 15 ? 1 : 2,
    mes: mes,
    anio: anio,
  };
}

function textoAyudaVerMas(tipoAplicacion) {
  const p = periodoVerMasActual();
  const qn = p.quincena === 1 ? "1ra." : "2da.";
  const periodo = qn + " quincena de " + MESES_VER_MAS[p.mes] + " " + p.anio;
  if (tipoAplicacion === "TODAS") {
    return "Se aplicara a todas las quincenas a partir de la " + periodo + ".";
  }
  return "Se aplicara solo a la " + periodo + ".";
}

function appendCssPersonal(form, data) {
  form.append("tipoDocumento", data.tipoDocumento || "CEDULA");
  form.append("dv", data.dv || "");
  form.append("numeroSso", data.numeroSso || "");
}

function aplicarPagoEnData(data_, pago) {
  const marcado = function (valor) {
    return String(valor) === "1" ? "1" : "0";
  };
  const texto = function (valor) {
    return String(valor == null ? "" : valor).toUpperCase();
  };
  const hay = pago && marcado(pago.existe) === "1";
  data_.pagoExiste = hay ? "1" : "0";
  data_.pagoTransferencia = hay ? marcado(pago.transferencia) : "0";
  data_.pagoYappy = hay ? marcado(pago.yappy) : "0";
  data_.yappyNombre = hay ? texto(pago.yappyNombre) : "";
  data_.yappyNumero = hay ? texto(pago.yappyNumero) : "";
  data_.pagoWestern = hay ? marcado(pago.western) : "0";
  data_.westernBeneficiario = hay ? texto(pago.westernBeneficiario) : "";
  data_.westernDocumento = hay ? texto(pago.westernDocumento) : "";
  data_.westernPais = hay ? texto(pago.westernPais) : "";
  data_.westernCiudad = hay ? texto(pago.westernCiudad) : "";
  data_.westernTelefono = hay ? texto(pago.westernTelefono) : "";
  data_.pagoEfectivo = hay ? marcado(pago.efectivo) : "0";
  data_.pagoOtro = hay ? marcado(pago.otro) : "0";
  data_.otroDescripcion = hay ? texto(pago.otroDescripcion) : "";
  data_.otroMetodo = hay ? texto(pago.otroMetodo) : "";
  data_.otroDatos = hay ? texto(pago.otroDatos) : "";
}

function partesDocumento(cedula) {
  const partes = String(cedula || "")
    .toUpperCase()
    .split("-")
    .map(function (parte) {
      return parte.trim();
    })
    .filter(Boolean);
  if (partes.length >= 3) {
    return {
      medio: partes[partes.length - 2],
      ultimo: partes[partes.length - 1],
    };
  }
  if (partes.length === 2) {
    return { medio: partes[0], ultimo: partes[1] };
  }
  const unico = partes[0] || "";
  return { medio: unico, ultimo: unico };
}

function baseDeNombre(nombre, cual) {
  const palabras = String(nombre || "")
    .toUpperCase()
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!palabras.length) return "";
  if (cual === "apellido") return palabras[palabras.length - 1];
  return palabras[0];
}

function combinacionClave(nombre, cedula, cual) {
  const base = baseDeNombre(nombre, cual);
  const partes = partesDocumento(cedula);
  return {
    usuario: base + partes.medio,
    clave: base + partes.ultimo,
  };
}

function Empleados(props) {
  const [listaOn, setlistaOn] = React.useState(false);
  const [listaTnOn, setlistaTnOn] = React.useState(false);
  const [verMasOn, setverMasOn] = React.useState(false);
  const [verMasLista, setverMasLista] = React.useState([]);
  const [verMasDesc, setverMasDesc] = React.useState("");
  const [verMasMonto, setverMasMonto] = React.useState("");
  const [verMasAplica, setverMasAplica] = React.useState("ESTA");
  const [listaSuOn, setlistaSuOn] = React.useState(false);
  const [listaDatosBOn, setlistaDatosBOn] = React.useState(false);
  const [flotadorIncInaOn, setflotadorIncInaOn] = React.useState(false);
  const [sedeGuardada, setSedeGuardada] = React.useState("");
  const [flotadorClaveOn, setflotadorClaveOn] = React.useState(false);
  const [baseClave, setBaseClave] = React.useState("nombre");
  const [usuarioClave, setUsuarioClave] = React.useState("");
  const [idClaveNueva, setIdClaveNueva] = React.useState("");
  const [claveGuardando, setClaveGuardando] = React.useState(false);
  const [flotadorMontoOn, setflotadorMontoOn] = React.useState(false);
  const [casosMonto, setCasosMonto] = React.useState([]);
  const [itemsMonto, setItemsMonto] = React.useState([]);
  const [casoMonto, setCasoMonto] = React.useState("");
  const [itemMonto, setItemMonto] = React.useState("");
  const [valorMonto, setValorMonto] = React.useState("");
  const cadenaClaveRef = React.useRef(false);
  const [fechaIncInaDesde, setfechaIncInaDesde] = React.useState("");
  const [fechaIncInaHasta, setfechaIncInaHasta] = React.useState("");

  const [personal, setpersonal] = React.useState([]);
  const [nominaP, setnominaP] = React.useState([]);
  const [nominaPS, setnominaPS] = React.useState([]);
  const [cuentaC, setcuentaC] = React.useState([]);
  const [horario, setHorario] = React.useState([]);
  const [activarHOn, setActivarHOn] = React.useState(false);
  const [btnnoauto2On, setbtnnoauto2On] = React.useState("NO");
  const [btnnoauto1On, setbtnnoauto1On] = React.useState("NO");
  const [mensajealerta, setmensajealerta] = React.useState(false);
  const [paso, setpaso] = React.useState(false);
  const [irutas, setirutas] = React.useState([]);
  const [mensaje, setmensaje] = React.useState("");

  const [horaE1, setHoraE1] = React.useState("");
  const [horaS1, setHoraS1] = React.useState("");
  const [horaE2, setHoraE2] = React.useState("");
  const [horaS2, setHoraS2] = React.useState("");
  const [horaTS1, setHoraTS1] = React.useState("");

  const [tiempoE1, setTiempoE1] = React.useState("");
  const [tiempoE2, setTiempoE2] = React.useState("");
  const [tiempoE3, setTiempoE3] = React.useState("");
  const [tiempoE4, setTiempoE4] = React.useState("");
  const [tiempoE5, setTiempoE5] = React.useState("");
  const [tiempoE6, setTiempoE6] = React.useState("");

  const [tiempoS1, setTiempoS1] = React.useState("");
  const [tiempoS2, setTiempoS2] = React.useState("");
  const [tiempoS3, setTiempoS3] = React.useState("");
  const [tiempoS4, setTiempoS4] = React.useState("");
  const [tiempoS5, setTiempoS5] = React.useState("");
  const [tiempoS6, setTiempoS6] = React.useState("");

  const [lunesCheck, setLunesCheck] = React.useState("");
  const [martesCheck, setMartesCheck] = React.useState("");
  const [miercolesCheck, setMiercolesCheck] = React.useState("");
  const [juevesCheck, setJuevesCheck] = React.useState("");
  const [viernesCheck, setViernesCheck] = React.useState("");
  const [sabadoCheck, setSabadoCheck] = React.useState("");
  const [fijoCheck, setFijoCheck] = React.useState("");
  const [fijoTerapiaCheck, setFijoTerapiaCheck] = React.useState("");

  const [loading, setloading] = React.useState(false);
  const [activarOn, setactivarOn] = React.useState(false);
  const [aprobarOn, setaprobarOn] = React.useState(false);
  const [trimestre, settrimestre] = React.useState(0);
  const [anopagar, setanopagar] = React.useState("");
  const [mesapagar, setmesapagar] = React.useState("");
  const [fijoTerapia, setfijoTerapia] = React.useState("");
  
  const [anio, setanio] = React.useState([]);
  const [mes, setmes] = React.useState([]);

  const [data, setData] = React.useState({
    cedula: "",
    cedulaOt: "",
    nombre: "",
    apellido: "",
    profesion: "",
    cargo: "",
    fechaIngreso: "",
    fechaEgreso: "",
    tiponomina: "",
    tiponominaA: "",
    status: "",
    statusA: "",
    statusDe: "",
    correo: "",
    fechaNaci: "",
    edad: "",
    direccion: "",
    nombreD1: "",
    edadD1: "",
    parentescoD1: "",
    nombreD2: "",
    edadD2: "",
    parentescoD2: "",
    nombreD3: "",
    edadD3: "",
    parentescoD3: "",
    nacionalidad: "",
    telefono: "",
    edocivil: "",
    cuenta: "",
    banco1: "",
    tcuenta: "",
    titular: "",
    horario: "",
    tcontrato: "",
    tcontratoOperativo: "",
    aprobado: "",
    salarioBaseMensual: "",
    horasDiaria: "",
    primaProduccion: "",
    diasSemanal: "",
    salarioHora: "",
    salarioDia: "",
    salarioQuincenal: "",
    salarioHoraPrima: "",
    salarioDiaPrima: "",
    salarioQuincenalPrima: "",
    sso: "9.75",
    ssoDecimo: "7.25",
    seguroEducativo: "1.25",
    cuentaContable2: "",
    sede: "",
    primaParteDecimo: "N",
    diaImpresionReporte: "",
    pagoExiste: "0",
    pagoTransferencia: "0",
    pagoYappy: "0",
    yappyNombre: "",
    yappyNumero: "",
    pagoWestern: "0",
    westernBeneficiario: "",
    westernDocumento: "",
    westernPais: "",
    westernCiudad: "",
    westernTelefono: "",
    pagoEfectivo: "0",
    pagoOtro: "0",
    otroDescripcion: "",
    otroMetodo: "",
    otroDatos: "",
    tipoDocumento: "CEDULA",
    dv: "",
    numeroSso: "",
  });
  const [sedes, setSedes] = React.useState([]);
  const [profesiones, setProfesiones] = React.useState([]);
  const [tituloM, settituloM] = React.useState("");
  const [cuerpoM, setcuerpoM] = React.useState("");
  const [xsso, setxsso] = React.useState("9.75");
  const [xssoDecimo, setxssoDecimo] = React.useState("7.25");
  const [xseguroEducativo, setxseguroEducativo] = React.useState("1.25");

  const limpiar = () => {
    setmensajealerta(false);
    setfijoTerapia("");

    setactivarOn(false);
    setSedeGuardada("");
    setflotadorClaveOn(false);
    setverMasOn(false);
    setverMasLista([]);
    setverMasDesc("");
    setverMasMonto("");
    setverMasAplica("ESTA");
    let data_ = Object.assign({}, data);
    data_ = {
      sso: "9.75",
      ssoDecimo: "7.25",
      seguroEducativo: "1.25",
    };
    setData(data_);
  };

  const cerrarLista = () => {
    //console.log(listaOn)
    if (listaOn) {
      setlistaOn(false);
    }
    if (!listaOn) {
      setlistaOn(true);
      buscarPersonalC();
    }
  };

  const cerrarListaTn = () => {
    //console.log(listaOn)
    if (listaTnOn) {
      setlistaTnOn(false);
    }
    if (!listaTnOn) {
      setlistaTnOn(true);
    }
  };

  const cerrarListaSu = () => {
    //console.log(listaOn)
    if (listaSuOn) {
      setlistaSuOn(false);
    }
    if (!listaSuOn) {
      setlistaSuOn(true);
    }
  };

  const activarH = () => {
    if (activarHOn) {
      cadenaClaveRef.current = false;
      setActivarHOn(false);
    }
    if (!activarHOn) {
      setActivarHOn(true);
    }
  };

  const cerrarListaDatosB = () => {
    //console.log(listaOn)
    if (listaDatosBOn) {
      setlistaDatosBOn(false);
    }
    if (!listaDatosBOn) {
      setlistaDatosBOn(true);
    }
  };

  const onChangePrimaParteDecimo = (e) => {
    let data_ = Object.assign({}, data);
    data_.primaParteDecimo = e.target.checked ? "S" : "N";
    setData(data_);
  };

  const onToggleOperativo = (flag) => {
    let data_ = Object.assign({}, data);
    let actual = codigoOperativo(data_.tcontratoOperativo);
    if ((actual & flag) === flag) {
      actual = actual - flag;
    } else {
      actual = actual + flag;
    }
    data_.tcontratoOperativo = actual > 0 ? String(actual) : "";
    setData(data_);
  };

  const onChange = (e) => {
    let index = e.target.getAttribute("id");
    let data_ = Object.assign({}, data);
    data_[index] = e.target.value;
    if (index === "dv") {
      data_[index] = String(e.target.value).replace(/\D/g, "").slice(0, 4);
    }
    if (index === "primaProduccion") {
      const n =
        parseFloat(String(e.target.value).replace(",", ".")) || 0;
      if (n <= 0) data_.primaParteDecimo = "N";
    }
    if (index === "tcontrato" && String(e.target.value) !== "5") {
      data_.tcontratoOperativo = "";
    }
    setData(data_);

    if (index === "trimestre") {
      settrimestre(e.target.value);
    }
    if (index === "anopagar") {
      setanopagar(e.target.value);
    }
    if (index === "mesapagar") {
      setmesapagar(e.target.value);
    }
  };

  const onChange1 = (e) => {
    let index = e.target.getAttribute("id");

    if (e.target.checked) {
      if (index === "lunesCheck") {
        setLunesCheck("SI");
      }
      if (index === "martesCheck") {
        setMartesCheck("SI");
      }
      if (index === "miercolesCheck") {
        setMiercolesCheck("SI");
      }
      if (index === "juevesCheck") {
        setJuevesCheck("SI");
      }
      if (index === "viernesCheck") {
        setViernesCheck("SI");
      }
      if (index === "sabadoCheck") {
        setSabadoCheck("SI");
      }
      if (index === "fijoCheck") {
        setFijoCheck("SI");
      }
      if (index === "fijoTerapiaCheck") {
        setFijoTerapiaCheck("SI");
        setFijoCheck("SI");
        horarioNomina("SI");
      }
    } else {
      if (index === "lunesCheck") {
        setLunesCheck("NO");
      }
      if (index === "martesCheck") {
        setMartesCheck("NO");
      }
      if (index === "miercolesCheck") {
        setMiercolesCheck("NO");
      }
      if (index === "juevesCheck") {
        setJuevesCheck("NO");
      }
      if (index === "viernesCheck") {
        setViernesCheck("NO");
      }
      if (index === "sabadoCheck") {
        setSabadoCheck("NO");
      }
      if (index === "fijoCheck") {
        setFijoCheck("");
      }
      if (index === "fijoTerapiaCheck") {
        setFijoTerapiaCheck("");
        horarioNomina("");
      }
    }
  };

  const onChange2 = (e) => {
    let index = e.target.getAttribute("id");
    let data_ = Object.assign({}, data);
    data_[index] = e.target.value;
    if (index === "tiponomina") {
      const tn = String(e.target.value);
      let permitidos = ["1", "3", "5"];
      if (tn === "5" || tn === "6") {
        permitidos = ["1", "5"];
      } else if (tn === "3") {
        permitidos = ["1", "3", "5"];
      }
      if (
        data_.tcontrato &&
        data_.tcontrato !== "0" &&
        permitidos.indexOf(String(data_.tcontrato)) === -1
      ) {
        data_.tcontrato = "";
      }
      if (String(data_.tcontrato) !== "5") {
        data_.tcontratoOperativo = "";
      }
    }
    setData(data_);

    buscarAsigDedu(e.target.value);
  };

  const opcionesTipoContrato = () => {
    const tn = String(data.tiponomina || "");
    const actual = String(data.tcontrato || "");
    const opts = [];
    opts.push({ value: "0", label: "-- Tipo Contrato --" });
    if (tn === "3") {
      opts.push({ value: "1", label: "Administrativo." });
      opts.push({ value: "3", label: "Honorario Profesionales." });
      opts.push({ value: "5", label: "Operativo." });
    } else if (tn === "5" || tn === "6") {
      opts.push({ value: "1", label: "Administrativo." });
      opts.push({ value: "5", label: "Operativo." });
      // Compatibilidad: si ya venía guardado honorario (3), no ocultarlo
      if (actual === "3") {
        opts.push({ value: "3", label: "Honorario Profesionales." });
      }
    } else {
      opts.push({ value: "1", label: "Administrativo." });
      opts.push({ value: "3", label: "Honorario Profesionales." });
      opts.push({ value: "5", label: "Operativo." });
    }
    return opts;
  };

  const onChange3 = (e) => {
    //console.log(e.target.getAttribute("id"));
    if (e.target.getAttribute("id") === "horaE1") {
      setHoraE1(e.target.value);
    }
    if (e.target.getAttribute("id") === "horaE2") {
      setHoraE2(e.target.value);
    }
    if (e.target.getAttribute("id") === "horaTS1") {
      setHoraTS1(e.target.value);
    }

    if (e.target.getAttribute("id") === "horaS1") {
      setHoraS1(e.target.value);
      // if (e.target.value.substring(0, 1) === "1") {
      //   setHoraS1(e.target.value);
      // } else {
      //   setHoraS1("");
      // }
    }
    if (e.target.getAttribute("id") === "horaS2") {
      setHoraS2(e.target.value);
      // if (e.target.value.substring(0, 1) === "1") {
      //   setHoraS2(e.target.value);
      // } else {
      //   setHoraS2("");
      // }
    }

    //console.log(e.target.name)
    //setopenvio(e.target.value);
    //console.log(e.target.value)
  };

  const handleClose = () => {
    setmensajealerta(false);
  };
  const botonnoautorizado = () => {
    if (btnnoauto1On === "SI") {
      setbtnnoauto1On("NO");
      setbtnnoauto2On("NO");
    } else {
      setbtnnoauto1On("SI");
    }
  };

  const cerrarLista2 = () => {
    //console.log(listaOn)
    if (paso) {
      setpaso(false);
    }
    if (!paso) {
      setpaso(true);
    }
  };

  const datosADM = () => {
    //console.log(listaOn)
    if (aprobarOn) {
      setaprobarOn(false);
      setverMasOn(false);
    }
    if (!aprobarOn) {
      setaprobarOn(true);
    }
  };

  const buscarAsigDedu = (e) => {
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("tipoNomina", e);
    form.append("boton", "buscarTipoN");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        let data_ = Object.assign({}, data);
        data_["cargo"] = res.data.variable5;
        data_["fechaIngreso"] = res.data.variable6;
        data_["fechaEgreso"] = res.data.variable7;
        data_["tiponomina"] = res.data.variable8;
        data_["tcontrato"] = res.data.variable40;
        data_["salarioBaseMensual"] = res.data.variable10;
        data_["horasDiaria"] = res.data.variable11;
        data_["primaProduccion"] = res.data.variable44 || "";
        data_["primaParteDecimo"] =
          res.data.variable50 === "S" ? "S" : "N";
        data_["diasSemanal"] = res.data.variable12;
        data_["salarioHora"] = res.data.variable13;
        data_["salarioDia"] = res.data.variable14;
        data_["salarioQuincenal"] = res.data.variable15;
        data_["salarioHoraPrima"] = res.data.variable51 || "";
        data_["salarioDiaPrima"] = res.data.variable52 || "";
        data_["salarioQuincenalPrima"] = res.data.variable53 || "";
        data_["sso"] = res.data.variable16;
        data_["ssoDecimo"] = res.data.variable17;
        data_["seguroEducativo"] = res.data.variable18;
        data_["horario"] = res.data.variable35;
        data_["cuentaContable2"] = res.data.variable42;
        data_["sede"] = res.data.variable43;
        setSedeGuardada(sedeGuardadaId(res.data.variable43));
        data_["diaImpresionReporte"] =
          res.data.variable54 >= 1 && res.data.variable54 <= 3
            ? String(res.data.variable54)
            : "";
        aplicarOperativoEnData(data_, res.data);
        setData(data_);
      } // else {
      //   setmensajealerta(true);
      //   settituloM("Menu Empleado.");
      //   setcuerpoM(res.data.variable2);
      // }
      //setpersonal(xpersonal);
    });
  };

  const consultarAdjuntos = () => {
    //console.log(e.target.files)
    setloading(true);
    const form_data = new FormData();

    form_data.append("cedula", data.cedula);
    form_data.append("boton", "Consultar");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/archivo2.php";
    axios
      .post(xurl, form_data, config)

      .then((res) => {
        setloading(false);
        let xrutas = res.data.variable3;
        if (res.data.variable1) {
          setirutas(xrutas);
        } else {
          setmensaje("El Colaborador no tiene Documentos Consignados");
        }
        setpaso(true);
        //console.log(res);
      });
  };

  const botonnoautorizado2 = () => {
    //console.log(this.state.btnemOn)
    if (btnnoauto2On === "SI") {
      setbtnnoauto2On("NO");
    } else {
      setbtnnoauto2On("SI");
    }
  };

  const buscarPersonalC = () => {
    let form = new FormData();
    form.append("boton", "buscarPersonalC");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      //setactivarOn(true);
      let xpersonal = res.data.variable1;
      setpersonal(xpersonal);
      //setpersonal(xpersonal);
    });
  };

  const buscarPersonalI = (e) => {
    let form = new FormData();
    form.append("cedula", e);
    form.append("boton", "buscarPersonalI");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        setactivarOn(true);
        setlistaOn(false);
        let data_ = Object.assign({}, data);
        data_["cedula"] = res.data.variable2;
        data_["cedulaOt"] = res.data.variable44;
        data_["nombre"] = res.data.variable3;
        data_["apellido"] = res.data.variable62 || "";
        data_["profesion"] = res.data.variable4;
        data_["cargo"] = res.data.variable5;
        data_["fechaIngreso"] = res.data.variable6;
        data_["fechaEgreso"] = res.data.variable7;
        data_["tiponominaA"] = res.data.variable8;
        data_["tiponomina"] = res.data.variable8;
        data_["cuentaContable2"] = res.data.variable42;
        data_["status"] = res.data.variable9;
        data_["correo"] = res.data.variable19;
        data_["statusA"] = res.data.variable20;
        data_["statusDe"] = res.data.variable43;

        data_["fechaNaci"] = res.data.variable21;
        data_["edad"] = res.data.variable22;
        data_["direccion"] = res.data.variable23;
        data_["nombreD1"] = res.data.variable24;
        data_["edadD1"] = res.data.variable25;
        data_["parentescoD1"] = res.data.variable26;
        data_["nombreD2"] = res.data.variable27;
        data_["edadD2"] = res.data.variable28;
        data_["parentescoD2"] = res.data.variable29;
        data_["nombreD3"] = res.data.variable30;
        data_["edadD3"] = res.data.variable31;
        data_["parentescoD3"] = res.data.variable32;
        data_["nacionalidad"] = res.data.variable33;

        data_["edocivil"] = res.data.variable34;
        data_["horario"] = res.data.variable35;
        data_["cuenta"] = res.data.variable36;
        data_["banco1"] = res.data.variable37;
        data_["tcuenta"] = res.data.variable38;
        data_["titular"] = res.data.variable39;
        data_["tcontrato"] = res.data.variable40;
        data_["aprobado"] = res.data.variable41;
        data_["telefono"] = res.data.variable45;
        data_["sede"] = res.data.variable47;
        setSedeGuardada(sedeGuardadaId(res.data.variable47));

        data_["salarioBaseMensual"] = res.data.variable10;
        data_["horasDiaria"] = res.data.variable11;
        data_["primaProduccion"] = res.data.variable49;
        data_["primaParteDecimo"] =
          res.data.variable50 === "S" ? "S" : "N";
        data_["diasSemanal"] = res.data.variable12;
        data_["salarioHora"] = res.data.variable13;
        data_["salarioDia"] = res.data.variable14;
        data_["salarioQuincenal"] = res.data.variable15;
        data_["salarioHoraPrima"] = res.data.variable51 || "";
        data_["salarioDiaPrima"] = res.data.variable52 || "";
        data_["salarioQuincenalPrima"] = res.data.variable53 || "";
        data_["sso"] = res.data.variable16;
        data_["ssoDecimo"] = res.data.variable17;
        data_["seguroEducativo"] = res.data.variable18;
        data_["diaImpresionReporte"] =
          res.data.variable54 >= 1 && res.data.variable54 <= 3
            ? String(res.data.variable54)
            : "";
        aplicarOperativoEnData(data_, res.data);
        aplicarPagoEnData(data_, res.data.variable56);
        aplicarCssEnData(data_, res.data);
        setData(data_);
        setfijoTerapia(res.data.variable48);
      } else {
        setmensajealerta(true);
        settituloM("Menu Empleado.");
        setcuerpoM(res.data.variable2);
      }
      //setpersonal(xpersonal);
    });
  };

  const buscarPersonal = (e) => {
    let form = new FormData();
    form.append("cedula", e);
    form.append("boton", "buscarPersonalI");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        setactivarOn(true);
        setlistaSuOn(false);
        let data_ = Object.assign({}, data);
        data_["cedula"] = res.data.variable2;
        data_["cedulaOt"] = res.data.variable44;
        data_["nombre"] = res.data.variable3;
        data_["apellido"] = res.data.variable62 || "";
        data_["profesion"] = res.data.variable4;
        data_["cargo"] = res.data.variable5;
        data_["fechaIngreso"] = res.data.variable6;
        data_["fechaEgreso"] = res.data.variable7;
        data_["tiponominaA"] = res.data.variable8;
        data_["tiponomina"] = res.data.variable8;
        data_["cuentaContable2"] = res.data.variable42;
        data_["status"] = res.data.variable9;
        data_["correo"] = res.data.variable19;
        data_["statusA"] = res.data.variable20;
        data_["statusDe"] = res.data.variable43;

        data_["fechaNaci"] = res.data.variable21;
        data_["edad"] = res.data.variable22;
        data_["direccion"] = res.data.variable23;
        data_["nombreD1"] = res.data.variable24;
        data_["edadD1"] = res.data.variable25;
        data_["parentescoD1"] = res.data.variable26;
        data_["nombreD2"] = res.data.variable27;
        data_["edadD2"] = res.data.variable28;
        data_["parentescoD2"] = res.data.variable29;
        data_["nombreD3"] = res.data.variable30;
        data_["edadD3"] = res.data.variable31;
        data_["parentescoD3"] = res.data.variable32;
        data_["nacionalidad"] = res.data.variable33;
        data_["edocivil"] = res.data.variable34;
        data_["horario"] = res.data.variable35;
        data_["cuenta"] = res.data.variable36;
        data_["banco1"] = res.data.variable37;
        data_["tcuenta"] = res.data.variable38;
        data_["titular"] = res.data.variable39;
        data_["tcontrato"] = res.data.variable40;
        data_["aprobado"] = res.data.variable41;
        data_["telefono"] = res.data.variable45;
        data_["sede"] = res.data.variable47;
        setSedeGuardada(sedeGuardadaId(res.data.variable47));

        data_["salarioBaseMensual"] = res.data.variable10;
        data_["horasDiaria"] = res.data.variable11;
        data_["diasSemanal"] = res.data.variable12;
        data_["salarioHora"] = res.data.variable13;
        data_["primaProduccion"] = res.data.variable49;
        data_["primaParteDecimo"] =
          res.data.variable50 === "S" ? "S" : "N";
        data_["salarioDia"] = res.data.variable14;
        data_["salarioQuincenal"] = res.data.variable15;
        data_["salarioHoraPrima"] = res.data.variable51 || "";
        data_["salarioDiaPrima"] = res.data.variable52 || "";
        data_["salarioQuincenalPrima"] = res.data.variable53 || "";
        data_["sso"] = res.data.variable16;
        data_["ssoDecimo"] = res.data.variable17;
        data_["seguroEducativo"] = res.data.variable18;
        data_["diaImpresionReporte"] =
          res.data.variable54 >= 1 && res.data.variable54 <= 3
            ? String(res.data.variable54)
            : "";
        aplicarOperativoEnData(data_, res.data);
        aplicarPagoEnData(data_, res.data.variable56);
        aplicarCssEnData(data_, res.data);
        setData(data_);
        setfijoTerapia(res.data.variable48);
      } else {
        setmensajealerta(true);
        settituloM("Menu Empleado.");
        setcuerpoM(res.data.variable2);
      }
      //setpersonal(xpersonal);
    });
  };

  const guardarEmpleado = (e) => {
    if (data.cedula.length > 0) {
      let form = new FormData();
      form.append("cedula", data.cedula);
      form.append("nombre", data.nombre);
      form.append("apellido", data.apellido || "");
      form.append("profesion", data.profesion);
      form.append("cargo", data.cargo);
      form.append("fechaIngreso", data.fechaIngreso);
      form.append("fechaEgreso", data.fechaEgreso);
      form.append("tiponomina", data.tiponomina);
      form.append("codigoContable", data.cuentaContable2);
      form.append("status", data.status);
      form.append("statusA", data.statusA);
      form.append("correo", data.correo);

      form.append("fechaNaci", data.fechaNaci);
      form.append("edad", data.edad);
      form.append("direccion", data.direccion);
      form.append("nombreD1", data.nombreD1);
      form.append("edadD1", data.edadD1);
      form.append("parentescoD1", data.parentescoD1);
      form.append("nombreD2", data.nombreD2);
      form.append("edadD2", data.edadD2);
      form.append("parentescoD2", data.parentescoD2);
      form.append("nombreD3", data.nombreD3);
      form.append("edadD3", data.edadD3);
      form.append("parentescoD3", data.parentescoD3);
      form.append("nacionalidad", data.nacionalidad);
      form.append("telefono", data.telefono);
      form.append("edocivil", data.edocivil);
      form.append("cuenta", data.cuenta);
      form.append("banco1", data.banco1);
      form.append("tcuenta", data.tcuenta);
      form.append("titular", data.titular);
      form.append("yappyNombre", data.yappyNombre || "");
      form.append("yappyNumero", data.yappyNumero || "");
      form.append("westernBeneficiario", data.westernBeneficiario || "");
      form.append("westernDocumento", data.westernDocumento || "");
      form.append("westernPais", data.westernPais || "");
      form.append("westernCiudad", data.westernCiudad || "");
      form.append("westernTelefono", data.westernTelefono || "");
      form.append("otroDescripcion", data.otroDescripcion || "");
      form.append("otroMetodo", data.otroMetodo || "");
      form.append("otroDatos", data.otroDatos || "");
      form.append("horario", data.horario);
      form.append("tcontrato", data.tcontrato);
      form.append("tipoContratoOperativo", codigoOperativoParaGuardar(data));
      appendCssPersonal(form, data);

      form.append("salarioBaseMensual", data.salarioBaseMensual);
      form.append("horasDiaria", data.horasDiaria);
      form.append("primaProduccion", data.primaProduccion || "");
      form.append("diasSemanal", data.diasSemanal);
      form.append("salarioHora", data.salarioHora);
      form.append("salarioDia", data.salarioDia);
      form.append("salarioQuincenal", data.salarioQuincenal);
      form.append("salarioHoraPrima", data.salarioHoraPrima || "");
      form.append("salarioDiaPrima", data.salarioDiaPrima || "");
      form.append("salarioQuincenalPrima", data.salarioQuincenalPrima || "");
      form.append("sso", data.sso);
      form.append("ssoDecimo", data.ssoDecimo);
      form.append("seguroEducativo", data.seguroEducativo);
      form.append("boton", "guardarEmpleado");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable1);
        //console.log(res.data.variable2);
        if (res.data.variable1) {
          setactivarOn(true);
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        } else {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        }
      });
    }
  };

  const aprobarC = () => {
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("boton", "AprobarColaborador");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log(res.data.variable1);
      //console.log(res.data.variable2);
      if (res.data.variable1) {
        setmensajealerta(true);
        settituloM("Menu Empleado.");
        setcuerpoM(res.data.variable2);
        let data_ = Object.assign({}, data);
        data_["aprobado"] = "SI";
        setData(data_);
      } else {
        setmensajealerta(true);
        settituloM("Menu Empleado.");
        setcuerpoM(res.data.variable2);
      }
    });
  };

  const abrirReporteIncIna = () => {
    if (!activarOn || !data.cedula) {
      setmensajealerta(true);
      settituloM("Incapacidades e Inasistencias");
      setcuerpoM("Debe tener un empleado abierto.");
      return;
    }
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    setfechaIncInaDesde(`${yyyy}-${mm}-01`);
    setfechaIncInaHasta(`${yyyy}-${mm}-${dd}`);
    setflotadorIncInaOn(true);
  };

  const generarReporteIncIna = () => {
    if (!fechaIncInaDesde || !fechaIncInaHasta) {
      setmensajealerta(true);
      settituloM("Incapacidades e Inasistencias");
      setcuerpoM("Indique la fecha desde y la fecha hasta.");
      return;
    }
    if (fechaIncInaDesde > fechaIncInaHasta) {
      setmensajealerta(true);
      settituloM("Incapacidades e Inasistencias");
      setcuerpoM("La fecha desde no puede ser mayor que la fecha hasta.");
      return;
    }
    const form = new FormData();
    form.append("cedula", data.cedula);
    form.append("cedulaOt", data.cedulaOt || "");
    form.append("nombre", data.nombre);
    form.append("fechaDesde", fechaIncInaDesde);
    form.append("fechaHasta", fechaIncInaHasta);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteIncapacidadInasistencia.php",
      responseType: "arraybuffer",
      data: form,
    })
      .then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
      .catch(function () {
        setmensajealerta(true);
        settituloM("Incapacidades e Inasistencias");
        setcuerpoM("Error al generar el reporte PDF.");
      });
  };

  const imprimirContrato = (e) => {
    console.log(data.tiponomina);
    let form = new FormData();
    form.append("nombre", data.nombre);
    form.append("cedula", data.cedula);
    form.append("cedulaOt", data.cedulaOt);
    form.append("edad", data.edad);
    form.append("nacionalidad", data.nacionalidad);
    form.append("edocivil", data.edocivil);
    form.append("direccion", data.direccion);

    form.append("nombreP1", data.nombreD1);
    form.append("nombreP2", data.nombreD2);
    form.append("nombreP3", data.nombreD3);
    form.append("edadP1", data.edadD1);
    form.append("edadP2", data.edadD2);
    form.append("edadP3", data.edadD3);
    form.append("parentescoP1", data.parentescoD1);
    form.append("parentescoP2", data.parentescoD2);
    form.append("parentescoP3", data.parentescoD3);

    form.append("sede", data.sede);
    form.append("cargo", data.cargo);
    form.append("fechaI", data.fechaIngreso);
    form.append("fechaE", data.fechaEgreso);
    form.append("diasSemanal", data.diasSemanal);
    form.append("horasDiaria", data.horasDiaria);
    form.append("salarioHora", data.salarioHora);
    form.append("horario", data.horario);
    form.append("salarioM", data.salarioBaseMensual);
    if (data.tiponomina === "1" && data.tcontrato === "1") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoTiempoDefinidoAD.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "2" && data.tcontrato === "1") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoTiempoIndefinidoAD.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "1" && data.tcontrato === "2") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoTiempoDefinidoDocente.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    
    if (data.tiponomina === "2" && data.tcontrato === "2") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoTiempoIndefinidoDocente.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "3" && data.tcontrato === "5") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoHonorarioP.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "3" && data.tcontrato !== "1" && data.tcontrato !== "5") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoHonorarioP.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }

    if (data.tiponomina === "3" && data.tcontrato === "1") {
      console.log("tipo contrato" + data.tcontrato);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoHonorarioPA.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }

    if (data.tiponomina === "5" && data.tcontrato === "1") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoTiempoDefinidoAD2.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "5" && data.tcontrato === "5") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoOperativoDefinido.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "6" && data.tcontrato === "1") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoTiempoIndefinidoAD2.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (data.tiponomina === "6" && data.tcontrato === "5") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoOperativoIndefinido.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (
      (data.tiponomina === "1" && data.tcontrato === "3") ||
      (data.tiponomina === "2" && data.tcontrato === "3") ||
      (data.tiponomina === "5" &&
        data.tcontrato !== "1" &&
        data.tcontrato !== "5" &&
        data.tcontrato !== "") ||
      (data.tiponomina === "6" &&
        data.tcontrato !== "1" &&
        data.tcontrato !== "5" &&
        data.tcontrato !== "")
    ) {
      setmensajealerta(true);
      settituloM("Menu Empleado.");
      setcuerpoM("Este tipo de opcion No tiene Reporte, verifique");
    }
  };

  const imprimirContratoTerapia = () => {
    let form = new FormData();
    form.append("nombre", data.nombre);
    form.append("cedula", data.cedula);
    form.append("cedulaOt", data.cedulaOt);
    form.append("edad", data.edad);
    form.append("nacionalidad", data.nacionalidad);
    form.append("edocivil", data.edocivil);
    form.append("direccion", data.direccion);
    form.append("nombreP1", data.nombreD1);
    form.append("nombreP2", data.nombreD2);
    form.append("nombreP3", data.nombreD3);
    form.append("edadP1", data.edadD1);
    form.append("edadP2", data.edadD2);
    form.append("edadP3", data.edadD3);
    form.append("parentescoP1", data.parentescoD1);
    form.append("parentescoP2", data.parentescoD2);
    form.append("parentescoP3", data.parentescoD3);
    form.append("sede", data.sede);
    form.append("cargo", data.cargo);
    form.append("fechaI", data.fechaIngreso);
    form.append("fechaE", data.fechaEgreso);
    form.append("diasSemanal", data.diasSemanal);
    form.append("horasDiaria", data.horasDiaria);
    form.append("salarioHora", data.salarioHora);
    form.append("horario", data.horario);
    form.append("salarioM", data.salarioBaseMensual);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoHonorarioP2.php",
      responseType: "arraybuffer",
      data: form,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  const imprimirContrato2 = (e) => {
    console.log(data.tiponomina);
    let form = new FormData();
    form.append("nombre", data.nombre);
    form.append("cedula", data.cedula);
    form.append("cedulaOt", data.cedulaOt);
    form.append("edad", data.edad);
    form.append("nacionalidad", data.nacionalidad);
    form.append("edocivil", data.edocivil);
    form.append("direccion", data.direccion);

    form.append("nombreP1", data.nombreD1);
    form.append("nombreP2", data.nombreD2);
    form.append("nombreP3", data.nombreD3);
    form.append("edadP1", data.edadD1);
    form.append("edadP2", data.edadD2);
    form.append("edadP3", data.edadD3);
    form.append("parentescoP1", data.parentescoD1);
    form.append("parentescoP2", data.parentescoD2);
    form.append("parentescoP3", data.parentescoD3);

    form.append("sede", data.sede);
    form.append("cargo", data.cargo);
    form.append("fechaI", data.fechaIngreso);
    form.append("fechaE", data.fechaEgreso);
    form.append("diasSemanal", data.diasSemanal);
    form.append("horasDiaria", data.horasDiaria);
    form.append("salarioHora", data.salarioHora);
    form.append("horario", data.horario);
    form.append("salarioM", data.salarioBaseMensual);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/contratoHonorarioP.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });

  };


  const urlNomina =
    "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";

  const abrirVerMas = () => {
    if (!activarOn) {
      return;
    }
    setverMasDesc("");
    setverMasMonto("");
    setverMasAplica("ESTA");
    setverMasOn(true);
    buscarVerMas();
  };

  const cerrarVerMas = () => {
    setverMasOn(false);
  };

  const buscarVerMas = () => {
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("boton", "buscarVerMas");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    axios.post(urlNomina, form, config).then((res) => {
      if (res.data.variable1) {
        setverMasLista(res.data.variable2 || []);
      } else {
        setverMasLista([]);
      }
    });
  };

  const guardarVerMas = () => {
    if (!verMasDesc) {
      setmensajealerta(true);
      settituloM("Ver Mas +");
      setcuerpoM("Seleccione una descripcion.");
      return;
    }
    const monto = parseFloat(String(verMasMonto).replace(",", ".")) || 0;
    if (monto <= 0) {
      setmensajealerta(true);
      settituloM("Ver Mas +");
      setcuerpoM("Indique un monto mayor a cero.");
      return;
    }
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("codigoDescripcion", verMasDesc);
    form.append("monto", String(monto));
    form.append("tipoAplicacion", verMasAplica);
    form.append("boton", "guardarVerMas");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    axios.post(urlNomina, form, config).then((res) => {
      if (res.data.variable1) {
        setverMasLista(res.data.variable2 || []);
        setverMasDesc("");
        setverMasMonto("");
        setverMasAplica("ESTA");
      } else {
        setmensajealerta(true);
        settituloM("Ver Mas +");
        setcuerpoM(res.data.variable2);
      }
    });
  };

  const eliminarVerMas = (idconcepto) => {
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("idconcepto", idconcepto);
    form.append("boton", "eliminarVerMas");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    axios.post(urlNomina, form, config).then((res) => {
      if (res.data.variable1) {
        setverMasLista(res.data.variable2 || []);
      } else {
        setmensajealerta(true);
        settituloM("Ver Mas +");
        setcuerpoM(res.data.variable2);
      }
    });
  };

  const tipoNominaCreada = () => {
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("boton", "buscarTipoNomina");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log(res.data.variable1);
      //console.log(res.data.variable2);
      let tnomip = res.data.variable1;
      setnominaP(tnomip);
      setlistaTnOn(true);
    });
  };

  const activarTN = (e) => {
    let form = new FormData();
    form.append("idtipoN", e);
    form.append("boton", "activarTipoNomina");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log(res.data.variable1);
      //console.log(res.data.variable2);
      if (res.data.variable1) {
        tipoNominaCreada();
      }
    });
  };

  const textoLleno = (valor) => String(valor == null ? "" : valor).trim() !== "";

  const opcionLlena = (valor) => {
    const texto = String(valor == null ? "" : valor).trim();
    return texto !== "" && texto !== "0" && texto !== "-Seleccione Sucursal-";
  };

  const fechaLlena = (valor) => {
    const texto = String(valor == null ? "" : valor).trim();
    return texto !== "" && texto !== "0000-00-00";
  };

  const faltantesAlModificar = () => {
    const faltan = [];
    if (!textoLleno(data.cedula)) faltan.push("Cédula");
    if (!textoLleno(data.nombre)) faltan.push("Nombre");
    if (!fechaLlena(data.fechaNaci)) faltan.push("Fecha de nacimiento");
    if (!textoLleno(data.edad)) faltan.push("Edad");
    if (!textoLleno(data.correo)) faltan.push("Correo");
    if (!textoLleno(data.direccion)) faltan.push("Dirección");
    if (!textoLleno(data.profesion)) faltan.push("Profesión");
    if (!textoLleno(data.nacionalidad)) faltan.push("Nacionalidad");
    if (!textoLleno(data.telefono)) faltan.push("Teléfono");
    const pagoPlanilla = data.pagoExiste === "1";
    if (!pagoPlanilla || data.pagoTransferencia === "1") {
      if (!textoLleno(data.cuenta)) faltan.push("Número de cuenta");
      if (!textoLleno(data.banco1)) faltan.push("Nombre del banco");
      if (!textoLleno(data.tcuenta)) faltan.push("Tipo de cuenta");
      if (!textoLleno(data.titular)) faltan.push("Titular de la cuenta");
    }
    if (pagoPlanilla && data.pagoYappy === "1") {
      if (!textoLleno(data.yappyNombre)) faltan.push("Nombre del titular de Yappy");
      if (!textoLleno(data.yappyNumero)) faltan.push("Número asociado de Yappy");
    }
    if (pagoPlanilla && data.pagoWestern === "1") {
      if (!textoLleno(data.westernBeneficiario)) faltan.push("Beneficiario de Western Union");
      if (!textoLleno(data.westernDocumento)) faltan.push("Cédula o pasaporte de Western Union");
      if (!textoLleno(data.westernPais)) faltan.push("País de Western Union");
      if (!textoLleno(data.westernCiudad)) faltan.push("Ciudad de Western Union");
      if (!textoLleno(data.westernTelefono)) faltan.push("Teléfono de Western Union");
    }
    if (pagoPlanilla && data.pagoOtro === "1") {
      if (!textoLleno(data.otroDescripcion)) faltan.push("Descripción del otro pago");
      if (!textoLleno(data.otroMetodo)) faltan.push("Método del otro pago");
      if (!textoLleno(data.otroDatos)) faltan.push("Datos del otro pago");
    }
    if (sedeGuardadaId(data.sede) === "") faltan.push("Sede");
    if (!opcionLlena(data.statusA)) faltan.push("Status administrativo");
    if (!opcionLlena(data.tiponomina)) faltan.push("Tipo de nómina");
    if (!opcionLlena(data.tcontrato)) faltan.push("Tipo de contrato");
    if (
      esContratoOperativo(data.tiponomina, data.tcontrato) &&
      codigoOperativo(data.tcontratoOperativo) === 0
    ) {
      faltan.push("Pago Unico o Por Terapia");
    }
    if (!fechaLlena(data.fechaIngreso)) faltan.push("Fecha de ingreso");
    const impresion = String(data.diaImpresionReporte == null ? "" : data.diaImpresionReporte).trim();
    if (impresion !== "1" && impresion !== "2" && impresion !== "3") {
      faltan.push("Opción de impresión en reportes");
    }
    return faltan;
  };

  const avisarSiFaltanDatos = () => {
    const faltan = faltantesAlModificar();
    if (faltan.length === 0) {
      return true;
    }
    setmensajealerta(true);
    settituloM("Menu Empleado.");
    setcuerpoM("Complete los datos antes de modificar: " + faltan.join(", ") + ".");
    return false;
  };

  const modificarEmpleado2 = (e) => {
    if (!avisarSiFaltanDatos()) {
      return;
    }
    let form = new FormData();
      form.append("cedula", data.cedula);
      form.append("nombre", data.nombre);
      form.append("apellido", data.apellido || "");
      form.append("profesion", data.profesion);
      form.append("cargo", data.cargo);
      form.append("fechaIngreso", data.fechaIngreso);
      form.append("fechaEgreso", data.fechaEgreso);
      form.append("tiponominaAnterior", data.tiponominaA);
      form.append("tiponomina", data.tiponomina);
      form.append("codigoContable", data.cuentaContable2);
      form.append("status", data.statusA);
      form.append("statusA", data.statusA);
      form.append("statusDe", data.statusDe);
      form.append("correo", data.correo);

      form.append("fechaNaci", data.fechaNaci);
      form.append("edad", data.edad);
      form.append("direccion", data.direccion);
      form.append("nombreD1", data.nombreD1);
      form.append("edadD1", data.edadD1);
      form.append("parentescoD1", data.parentescoD1);
      form.append("nombreD2", data.nombreD2);
      form.append("edadD2", data.edadD2);
      form.append("parentescoD2", data.parentescoD2);
      form.append("nombreD3", data.nombreD3);
      form.append("edadD3", data.edadD3);
      form.append("parentescoD3", data.parentescoD3);
      form.append("nacionalidad", data.nacionalidad);
      form.append("telefono", data.telefono);
      form.append("edocivil", data.edocivil);
      form.append("cuenta", data.cuenta);
      form.append("banco1", data.banco1);
      form.append("tcuenta", data.tcuenta);
      form.append("titular", data.titular);
      form.append("yappyNombre", data.yappyNombre || "");
      form.append("yappyNumero", data.yappyNumero || "");
      form.append("westernBeneficiario", data.westernBeneficiario || "");
      form.append("westernDocumento", data.westernDocumento || "");
      form.append("westernPais", data.westernPais || "");
      form.append("westernCiudad", data.westernCiudad || "");
      form.append("westernTelefono", data.westernTelefono || "");
      form.append("otroDescripcion", data.otroDescripcion || "");
      form.append("otroMetodo", data.otroMetodo || "");
      form.append("otroDatos", data.otroDatos || "");
      form.append("horario", data.horario);
      form.append("tcontrato", data.tcontrato);
      form.append("tipoContratoOperativo", codigoOperativoParaGuardar(data));
      form.append("sede", data.sede);
      form.append("dependiente2Abierto", btnnoauto1On);
      form.append("dependiente3Abierto", btnnoauto2On);
      appendCssPersonal(form, data);

      form.append("salarioBaseMensual", data.salarioBaseMensual);
      form.append("horasDiaria", data.horasDiaria);
      form.append("primaProduccion", data.primaProduccion || "");
      form.append(
        "primaParteDecimo",
        (parseFloat(String(data.primaProduccion || "").replace(",", ".")) ||
          0) > 0 && data.primaParteDecimo === "S"
          ? "S"
          : "N"
      );
      form.append("diasSemanal", data.diasSemanal);
      form.append("salarioHora", data.salarioHora);
      form.append("salarioDia", data.salarioDia);
      form.append("salarioQuincenal", data.salarioQuincenal);
      form.append("salarioHoraPrima", data.salarioHoraPrima || "");
      form.append("salarioDiaPrima", data.salarioDiaPrima || "");
      form.append("salarioQuincenalPrima", data.salarioQuincenalPrima || "");
      form.append("sso", xsso);
      form.append("ssoDecimo", xssoDecimo);
      form.append("seguroEducativo", xseguroEducativo);
      form.append("diaImpresionReporte", data.diaImpresionReporte || "");
      form.append("boton", "modificarEmpleado");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable1);
        //console.log(res.data.variable2);
        if (res.data.variable1) {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
          let data_ = Object.assign({}, data);
          data_["tiponominaA"] = data.tiponomina;
          data_["status"] = data.statusA;
          setData(data_);
          const sedeOk = sedeGuardadaId(data.sede);
          setSedeGuardada(sedeOk);
          continuarConfiguracion(true, sedeOk);
        } else {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        }
      });
  };

  const elegirBaseClave = (cual) => {
    const baseNombre =
      cual === "apellido" && String(data.apellido || "").trim()
        ? data.apellido
        : data.nombre;
    const combo = combinacionClave(baseNombre, data.cedula, cual === "apellido" && String(data.apellido || "").trim() ? "nombre" : cual);
    setBaseClave(cual);
    setUsuarioClave(combo.usuario);
    setIdClaveNueva(combo.clave);
  };

  const continuarConfiguracion = (desdeModificar, sedeForzada) => {
    const sede = sedeForzada != null ? sedeForzada : sedeGuardada;
    if (sedeGuardadaId(sede) === "" || String(data.sede) !== String(sede)) {
      return;
    }
    const form = new FormData();
    form.append("cedula", data.cedula);
    form.append("boton", "pasoClaveNueva");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php",
        form,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        if (!res.data.variable1) {
          setmensajealerta(true);
          settituloM("Crear clave");
          setcuerpoM(res.data.variable2 || "No se pudo revisar la configuración.");
          return;
        }
        if (res.data.variable2 === "horario") {
          cadenaClaveRef.current = true;
          horarioNomina("");
          return;
        }
        if (res.data.variable2 === "monto") {
          abrirPasoMonto();
          return;
        }
        if (res.data.variable2 === "clave") {
          elegirBaseClave("nombre");
          setflotadorClaveOn(true);
          return;
        }
        if (!desdeModificar) {
          setmensajealerta(true);
          settituloM("Crear clave");
          setcuerpoM("Este empleado ya tiene una clave.");
        }
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Crear clave");
        setcuerpoM("No se pudo revisar la configuración del empleado.");
      });
  };

  const salirPasoMonto = () => {
    setmensajealerta(false);
    setflotadorMontoOn(false);
    const form = new FormData();
    form.append("cedula", data.cedula);
    form.append("desde", "monto");
    form.append("boton", "pasoClaveNueva");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php",
        form,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        if (!res.data.variable1) {
          setmensajealerta(true);
          settituloM("Crear clave");
          setcuerpoM(res.data.variable2 || "No se pudo revisar la configuración.");
          return;
        }
        if (res.data.variable2 === "clave") {
          elegirBaseClave("nombre");
          setflotadorClaveOn(true);
        }
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Crear clave");
        setcuerpoM("No se pudo revisar la configuración del empleado.");
      });
  };

  const abrirPasoMonto = () => {
    setCasoMonto("");
    setItemMonto("");
    setValorMonto("");
    setItemsMonto([]);
    const form = new FormData();
    form.append("boton", "Consultar");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/maestroCasosPHP.php",
        form,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        setCasosMonto(Array.isArray(res.data) ? res.data : []);
        setflotadorMontoOn(true);
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Monto por terapia");
        setcuerpoM("No se pudieron cargar las especialidades.");
      });
  };

  const cambiarCasoMonto = (valor) => {
    setCasoMonto(valor);
    setItemMonto("");
    setItemsMonto([]);
    if (!valor) return;
    const form = new FormData();
    form.append("especialidad", valor);
    form.append("boton", "consultaInventarioFacturar");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/inventario.php",
        form,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        setItemsMonto(res.data.variable1 ? res.data.variable2 || [] : []);
      });
  };

  const guardarMontoNuevo = () => {
    if (!casoMonto || !itemMonto || !String(valorMonto).trim()) {
      setmensajealerta(true);
      settituloM("Monto por terapia");
      setcuerpoM("Indique la especialidad, la terapia y el monto.");
      return;
    }
    const form = new FormData();
    form.append("especialidad", casoMonto);
    form.append("especialista", data.cedula);
    form.append("codigoItem", itemMonto);
    form.append("monto", valorMonto);
    form.append("especialista2", "");
    form.append("monto2", "");
    form.append("boton", "Grabar");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarPagosTerapia.php",
        form,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        if (res.data.variable1) {
          setItemMonto("");
          setValorMonto("");
          setmensajealerta(true);
          settituloM("Monto por terapia");
          setcuerpoM("El monto se guardó. Puede agregar otro ítem o salir para continuar.");
        } else {
          setmensajealerta(true);
          settituloM("Monto por terapia");
          setcuerpoM("No se pudo guardar el monto. Verifique si esa terapia ya está asociada.");
        }
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Monto por terapia");
        setcuerpoM("No se pudo guardar el monto.");
      });
  };

  const guardarClaveEmpleado = () => {
    if (claveGuardando) return;
    if (sedeGuardadaId(sedeGuardada) === "") {
      setmensajealerta(true);
      settituloM("Crear clave");
      setcuerpoM("Guarde la sede con Modificar Empleado antes de crear la clave.");
      return;
    }
    if (!String(usuarioClave).trim() || !String(idClaveNueva).trim()) {
      setmensajealerta(true);
      settituloM("Crear clave");
      setcuerpoM("Indique el usuario y la clave.");
      return;
    }
    setClaveGuardando(true);
    const form = new FormData();
    form.append("cedula", data.cedula);
    form.append("nombre", data.nombre);
    form.append("usuario", usuarioClave);
    form.append("idclave", idClaveNueva);
    form.append("sede", sedeGuardada);
    form.append("boton", "crearClaveEmpleado");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php",
        form,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        setmensajealerta(true);
        settituloM("Crear clave");
        setcuerpoM(res.data.variable2 || "No se pudo crear la clave.");
        if (res.data.variable1) {
          setflotadorClaveOn(false);
        }
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Crear clave");
        setcuerpoM("No se pudo crear la clave.");
      })
      .finally(() => {
        setClaveGuardando(false);
      });
  };

  const modificarEmpleado = (e) => {
    if (!avisarSiFaltanDatos()) {
      return;
    }
    let form = new FormData();
      form.append("cedula", data.cedula);
      form.append("nombre", data.nombre);
      form.append("apellido", data.apellido || "");
      form.append("profesion", data.profesion);
      form.append("cargo", data.cargo);
      form.append("fechaIngreso", data.fechaIngreso);
      form.append("fechaEgreso", data.fechaEgreso);
      form.append("tiponominaAnterior", data.tiponominaA);
      form.append("tiponomina", data.tiponomina);
      form.append("codigoContable", data.cuentaContable2);
      form.append("status", data.statusA);
      form.append("statusA", data.statusA);
      form.append("correo", data.correo);

      form.append("fechaNaci", data.fechaNaci);
      form.append("edad", data.edad);
      form.append("direccion", data.direccion);
      form.append("nombreD1", data.nombreD1);
      form.append("edadD1", data.edadD1);
      form.append("parentescoD1", data.parentescoD1);
      form.append("nombreD2", data.nombreD2);
      form.append("edadD2", data.edadD2);
      form.append("parentescoD2", data.parentescoD2);
      form.append("nombreD3", data.nombreD3);
      form.append("edadD3", data.edadD3);
      form.append("parentescoD3", data.parentescoD3);
      form.append("nacionalidad", data.nacionalidad);
      form.append("telefono", data.telefono);
      form.append("edocivil", data.edocivil);
      form.append("cuenta", data.cuenta);
      form.append("banco1", data.banco1);
      form.append("tcuenta", data.tcuenta);
      form.append("titular", data.titular);
      form.append("yappyNombre", data.yappyNombre || "");
      form.append("yappyNumero", data.yappyNumero || "");
      form.append("westernBeneficiario", data.westernBeneficiario || "");
      form.append("westernDocumento", data.westernDocumento || "");
      form.append("westernPais", data.westernPais || "");
      form.append("westernCiudad", data.westernCiudad || "");
      form.append("westernTelefono", data.westernTelefono || "");
      form.append("otroDescripcion", data.otroDescripcion || "");
      form.append("otroMetodo", data.otroMetodo || "");
      form.append("otroDatos", data.otroDatos || "");
      form.append("horario", data.horario);
      form.append("tcontrato", data.tcontrato);
      form.append("tipoContratoOperativo", codigoOperativoParaGuardar(data));
      form.append("sede", data.sede);
      form.append("dependiente2Abierto", btnnoauto1On);
      form.append("dependiente3Abierto", btnnoauto2On);
      appendCssPersonal(form, data);

      form.append("salarioBaseMensual", data.salarioBaseMensual);
      form.append("horasDiaria", data.horasDiaria);
      form.append("primaProduccion", data.primaProduccion || "");
      form.append(
        "primaParteDecimo",
        (parseFloat(String(data.primaProduccion || "").replace(",", ".")) ||
          0) > 0 && data.primaParteDecimo === "S"
          ? "S"
          : "N"
      );
      form.append("diasSemanal", data.diasSemanal);
      form.append("salarioHora", data.salarioHora);
      form.append("salarioDia", data.salarioDia);
      form.append("salarioQuincenal", data.salarioQuincenal);
      form.append("salarioHoraPrima", data.salarioHoraPrima || "");
      form.append("salarioDiaPrima", data.salarioDiaPrima || "");
      form.append("salarioQuincenalPrima", data.salarioQuincenalPrima || "");
      form.append("sso", xsso);
      form.append("ssoDecimo", xssoDecimo);
      form.append("seguroEducativo", xseguroEducativo);
      form.append("diaImpresionReporte", data.diaImpresionReporte || "");
      form.append("boton", "modificarEmpleado");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable1);
        //console.log(res.data.variable2);
        if (res.data.variable1) {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
          let data_ = Object.assign({}, data);
          data_["tiponominaA"] = data.tiponomina;
          data_["status"] = data.statusA;
          setData(data_);
          const sedeOk = sedeGuardadaId(data.sede);
          setSedeGuardada(sedeOk);
          continuarConfiguracion(true, sedeOk);
        } else {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        }
      });
  };

  const empleadosSusp = () => {
    let form = new FormData();
    form.append("boton", "buscarSuspendidos");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log(res.data.variable1);
      //console.log(res.data.variable2);
      let tnomipS = res.data.variable1;
      setnominaPS(tnomipS);
      setlistaSuOn(true);
    });
  };

  const guardarHorario = () => {
    if (
      horaE1.length > 0 ||
      horaS1.length > 0 ||
      horaE2.length > 0 ||
      horaS2.length > 0 ||
      horaTS1.length > 0
    ) {
      let form = new FormData();
      // if (horaE1.length === 5 && horaS1.length === 5) {
      form.append("cedulaPersonal", data.cedula);
      form.append("horaEntrada1", horaE1);
      form.append("horaSalida1", horaS1);
      form.append("horaEntrada2", horaE2);
      form.append("horaSalida2", horaS2);
      form.append("horaTope", horaTS1);
      form.append("dia1", lunesCheck);
      form.append("dia2", martesCheck);
      form.append("dia3", miercolesCheck);
      form.append("dia4", juevesCheck);
      form.append("dia5", viernesCheck);
      form.append("dia6", sabadoCheck);
      form.append("fijo", fijoCheck);
      form.append("fijoTerapia", fijoTerapiaCheck);
      form.append("tipoAsistencia", "1");
      form.append("boton", "crearHorario");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asistencia.php";
      axios.post(xurl, form, config).then((res) => {
        if (res.data.variable1) {
          const sigueCadena = cadenaClaveRef.current;
          if (sigueCadena) {
            cadenaClaveRef.current = false;
            setActivarHOn(false);
            continuarConfiguracion(false);
          } else {
            horarioNomina("");
          }
          setLunesCheck("");
          setMartesCheck("");
          setMiercolesCheck("");
          setJuevesCheck("");
          setViernesCheck("");
          setSabadoCheck("");
          setFijoCheck("");
          setFijoTerapiaCheck("");

          if (!sigueCadena) {
            setmensajealerta(true);
            settituloM("Menu Horario Empleado.");
            setcuerpoM("El Horario se Cargo Correctamente... ");
          }
        } else {
          setmensajealerta(true);
          settituloM("Menu Horario Empleado.");
          setcuerpoM("Hubo un Error verifique por favor Gracias... ");
        }
      });
    } else {
      setmensajealerta(true);
      settituloM("Menu Horario Empleado.");
      setcuerpoM("Los campos de Horas estan vacios");
    }
  };

  const horarioNomina = (e) => {
    let form = new FormData();
    form.append("cedula", data.cedula);
    form.append("fijoTerapia", e);
    form.append("boton", "buscarHorarioInd");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/asistencia.php";
    axios.post(xurl, form, config).then((res) => {
      // moment(mensaje.variable3).format("hh:MM A")
      if (res.data.variable2 !== "00:00:00") {
        setTiempoE1(res.data.variable2);
      } else {
        setTiempoE1("");
      }
      if (res.data.variable3 !== "00:00:00") {
        setTiempoS1(res.data.variable3);
      } else {
        setTiempoS1("");
      }
      if (res.data.variable4 !== "00:00:00") {
        setTiempoE2(res.data.variable4);
      } else {
        setTiempoE2("");
      }
      if (res.data.variable5 !== "00:00:00") {
        setTiempoS2(res.data.variable5);
      } else {
        setTiempoS2("");
      }
      if (res.data.variable6 !== "00:00:00") {
        setTiempoE3(res.data.variable6);
      } else {
        setTiempoE3("");
      }
      if (res.data.variable7 !== "00:00:00") {
        setTiempoS3(res.data.variable7);
      } else {
        setTiempoS3("");
      }
      if (res.data.variable8 !== "00:00:00") {
        setTiempoE4(res.data.variable8);
      } else {
        setTiempoE4("");
      }
      if (res.data.variable9 !== "00:00:00") {
        setTiempoS4(res.data.variable9);
      } else {
        setTiempoS4("");
      }
      if (res.data.variable10 !== "00:00:00") {
        setTiempoE5(res.data.variable10);
      } else {
        setTiempoE5("");
      }
      if (res.data.variable11 !== "00:00:00") {
        setTiempoS5(res.data.variable11);
      } else {
        setTiempoS5("");
      }
      if (res.data.variable12 !== "00:00:00") {
        setTiempoE6(res.data.variable12);
      } else {
        setTiempoE6("");
      }
      if (res.data.variable13 !== "00:00:00") {
        setTiempoS6(res.data.variable13);
      } else {
        setTiempoS6("");
      }
      if (res.data.variable14 !== "00:00:00") {
        setHoraE2(res.data.variable14);
      } else {
        setHoraE2("");
      }
      if (res.data.variable15 !== "00:00:00") {
        setHoraS2(res.data.variable15);
      } else {
        setHoraS2("");
      }
      if (res.data.variable16 !== "00:00:00") {
        setHoraTS1(res.data.variable16);
      } else {
        setHoraTS1("");
      }
      if (e !== "SI") {
        if (res.data.variable17 === "SI") {
          setFijoCheck("SI");
        } else {
          setFijoCheck("");
        }
      }
      if (e === "SI") {
        setFijoCheck("SI");
        setFijoTerapiaCheck("SI");
      }

      setActivarHOn(true);
    });
  };

  const eliminarEmpleado = () => {
    if (data.cedula.length > 0) {
      let form = new FormData();
      form.append("cedula", data.cedula);
      form.append("boton", "eliminarEmpleado");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable4);
        //console.log(res.data.variable3);
        if (res.data.variable1) {
          limpiar();
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        } else {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        }
      });
    }
  };

  const calcular = () => {
    const diasMes = 26;
    let sdia = Number.parseFloat(data.salarioBaseMensual / diasMes).toFixed(2);
    let sqince = Number.parseFloat(data.salarioBaseMensual / 2).toFixed(2);
    let shora = Number.parseFloat(sdia / data.horasDiaria).toFixed(2);

    const primaMensual =
      parseFloat(String(data.primaProduccion || "").replace(",", ".")) || 0;
    let sdiaPrima = "0";
    let sqincePrima = "0";
    let shoraPrima = "0";
    if (primaMensual > 0) {
      sdiaPrima = Number.parseFloat(primaMensual / diasMes).toFixed(2);
      sqincePrima = Number.parseFloat(primaMensual / 2).toFixed(2);
      shoraPrima =
        parseFloat(data.horasDiaria) > 0
          ? Number.parseFloat(sdiaPrima / data.horasDiaria).toFixed(2)
          : "0";
    }

    let data_ = Object.assign({}, data);
    data_["salarioQuincenal"] = sqince;
    data_["salarioDia"] = sdia;
    data_["salarioHora"] = shora;
    data_["salarioDiaPrima"] = sdiaPrima;
    data_["salarioQuincenalPrima"] = sqincePrima;
    data_["salarioHoraPrima"] = shoraPrima;
    setData(data_);
  };

  const eliarchivo = (e) => {
    //console.log(e);
    setloading(true);

    const form_data = new FormData();
    form_data.append("cedula", data.cedula);
    form_data.append("archivoArriba", e);
    form_data.append("boton", "Eliminar");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/archivo2.php";
    axios
      .post(xurl, form_data, config)

      .then((res) => {
        setloading(false);
        let xrutas = res.data.variable3;
        if (res.data.variable1) {
          setirutas(xrutas);
        } else {
          setirutas(xrutas);
          setmensaje(
            "Es posible que uno o mas archivos no fueron guardados en el servidor"
          );
        }
        //console.log(res);
      });
  };

  const Upload = (e) => {
    //console.log(e.target.files)
    setloading(true);
    const form_data = new FormData();

    let name_fvar = "";
    for (let x = 0; x < e.target.files.length; x++) {
      name_fvar = "file_" + String(x + 1);
      form_data.append(name_fvar, e.target.files[x]);
      //console.log(name_fvar)
    }
    form_data.append("cedula", data.cedula);
    form_data.append("boton", "Guardar");
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/archivo2.php";
    axios
      .post(xurl, form_data, config)

      .then((res) => {
        setloading(false);
        if (res.data.variable1) {
          // alert ('Los ArDocumentos fueron enviados exitosamente');
          let xrutas = res.data.variable3;

          setirutas(xrutas);
        } else {
          if (res.data.variable2.length > 0) {
            setpaso(true);
            setmensaje(res.data.variable2);
          } else {
            setpaso(true);
            setmensaje(
              "Es posible que uno o mas archivos no fueron guardados en el servidor"
            );
          }
        }
        //console.log(res);
      });
  };

  const ClickUpload = (e) => {
    document.getElementById("upload-file").click();
  };

  const datosBanco = () => {
    let form = new FormData();
    form.append("anoapagar", anopagar);
    form.append("trimestre", trimestre);
    form.append("mesapagar", mesapagar);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteDatosBancarios.php",
      responseType: "arraybuffer",
      data: form,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  const cargarCuentas = () => {
    let form = new FormData();
    form.append("boton", "buscarCodigosContablesAsientos");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/contabilidad.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log("paso "+res.data.variable2)
      let xcuentas = res.data.variable1;
      setcuentaC(xcuentas);
    });
  };

  const cargarFechas = () => {
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/fecha.php";
    axios.post(xurl).then((res) => {
      if (res.data.variable1) {
        let xmes = res.data.variable1;
        let xanio = res.data.variable2;
        //let xdia = res.data.variable3;
        //dia: xdia,
        setmes(xmes);
        setanio(xanio);
      }
    });
  };

  React.useEffect(() => {
    if (!profesiones.length) {
      return;
    }
    setData(function (previo) {
      if (!previo.profesion) {
        return previo;
      }
      const unica = profesionDeLista(previo.profesion, profesiones);
      if (unica === previo.profesion) {
        return previo;
      }
      return Object.assign({}, previo, { profesion: unica });
    });
  }, [profesiones, data.profesion]);

  React.useEffect(() => {
    //console.log(props.cedulaempleado);
    cargarFechas();
    cargarCuentas();
    fetchSedes().then(setSedes);
    const formProf = new FormData();
    formProf.append("boton", "listarProfesiones");
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php",
        formProf,
        { headers: { "Content-Type": "text/html" } }
      )
      .then(function (res) {
        if (res.data.variable1 && Array.isArray(res.data.variable2)) {
          setProfesiones(res.data.variable2);
        }
      });
    if (props.cedulaempleado.length > 0) {
      buscarPersonal(props.cedulaempleado);
    }
    //buscarPersonalC();
  }, []);
  return (
    <div className="principal-pago row">
      <div className="contenedor-cxcd col-12">
        <div className="titulo-cxc ">
          <p>ADICIONAR EMPLEADOS A LA NOMINA. </p>
        </div>
        {mensajealerta === true && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}
        {flotadorMontoOn && (
          <div className="incina-flotador">
            <div className="incina-modulo">
              <div className="incina-header">
                <h2 className="incina-titulo">Monto por terapia</h2>
                <button
                  type="button"
                  className="incina-cerrar"
                  onClick={salirPasoMonto}
                >
                  X
                </button>
              </div>
              <div className="incina-cuerpo">
                <p className="incina-label">{data.nombre}</p>
                <div className="incina-fila">
                  <label className="incina-label">Especialidad</label>
                  <select
                    className="incina-input"
                    value={casoMonto}
                    onChange={(e) => cambiarCasoMonto(e.target.value)}
                  >
                    <option value="">Seleccione especialidad</option>
                    {casosMonto.map(function (item) {
                      return (
                        <option key={item.variable1} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="incina-fila">
                  <label className="incina-label">Terapia</label>
                  <select
                    className="incina-input"
                    value={itemMonto}
                    onChange={(e) => setItemMonto(e.target.value)}
                  >
                    <option value="">Seleccione terapia</option>
                    {itemsMonto.map(function (item) {
                      return (
                        <option key={item.variable1} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="incina-fila">
                  <label className="incina-label">Monto</label>
                  <input
                    type="text"
                    className="incina-input"
                    value={valorMonto}
                    onChange={(e) => setValorMonto(e.target.value)}
                  />
                </div>
                <p className="incina-label">
                  Puede guardar varios ítems. Salir continúa con la clave.
                </p>
              </div>
              <div className="incina-botones">
                <button type="button" className="boton" onClick={guardarMontoNuevo}>
                  Guardar monto
                </button>
                <button type="button" className="boton" onClick={salirPasoMonto}>
                  Salir
                </button>
              </div>
            </div>
          </div>
        )}
        {flotadorClaveOn && (
          <div className="incina-flotador">
            <div className="incina-modulo">
              <div className="incina-header">
                <h2 className="incina-titulo">Crear clave</h2>
                <button
                  type="button"
                  className="incina-cerrar"
                  onClick={() => setflotadorClaveOn(false)}
                >
                  X
                </button>
              </div>
              <div className="incina-cuerpo">
                <div className="incina-fila">
                  <label className="incina-label">
                    <input
                      type="radio"
                      name="baseClave"
                      checked={baseClave === "nombre"}
                      onChange={() => elegirBaseClave("nombre")}
                    />{" "}
                    Primer nombre
                  </label>
                  <label className="incina-label">
                    <input
                      type="radio"
                      name="baseClave"
                      checked={baseClave === "apellido"}
                      onChange={() => elegirBaseClave("apellido")}
                    />{" "}
                    Apellido
                  </label>
                </div>
                <div className="incina-fila">
                  <label className="incina-label">Usuario</label>
                  <input
                    type="text"
                    className="incina-input"
                    value={usuarioClave}
                    onChange={(e) => setUsuarioClave(e.target.value.toUpperCase())}
                  />
                </div>
                <div className="incina-fila">
                  <label className="incina-label">Clave</label>
                  <input
                    type="text"
                    className="incina-input"
                    value={idClaveNueva}
                    onChange={(e) => setIdClaveNueva(e.target.value.toUpperCase())}
                  />
                </div>
                <p className="incina-label">
                  El usuario usa el tramo del medio del documento y la clave el último. Puede corregirlos antes de guardar. Sede: {sedeGuardada}
                </p>
              </div>
              <div className="incina-botones">
                <button
                  type="button"
                  className="boton"
                  onClick={guardarClaveEmpleado}
                  disabled={claveGuardando}
                >
                  Guardar clave
                </button>
                <button
                  type="button"
                  className="boton"
                  onClick={() => setflotadorClaveOn(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
        {flotadorIncInaOn && (
          <div className="incina-flotador">
            <div className="incina-modulo">
              <div className="incina-header">
                <h2 className="incina-titulo">Incapacidades e Inasistencias</h2>
                <button
                  type="button"
                  className="incina-cerrar"
                  onClick={() => setflotadorIncInaOn(false)}
                >
                  X
                </button>
              </div>
              <div className="incina-cuerpo">
                <div className="incina-fila">
                  <label className="incina-label">Desde:</label>
                  <input
                    type="date"
                    className="incina-input"
                    value={fechaIncInaDesde}
                    onChange={(e) => setfechaIncInaDesde(e.target.value)}
                  />
                </div>
                <div className="incina-fila">
                  <label className="incina-label">Hasta:</label>
                  <input
                    type="date"
                    className="incina-input"
                    value={fechaIncInaHasta}
                    onChange={(e) => setfechaIncInaHasta(e.target.value)}
                  />
                </div>
              </div>
              <div className="incina-botones">
                <button
                  type="button"
                  className="boton"
                  onClick={generarReporteIncIna}
                >
                  Generar PDF
                </button>
                <button
                  type="button"
                  className="boton"
                  onClick={() => setflotadorIncInaOn(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
        {loading === true && (
          <div className="cont-spinner row">
            <div className="spinner col-6">
              <RingLoader
                clasName="spinner"
                sizeUnit={"px"}
                size={160}
                width={19}
                radius={20}
                height={160}
                color={"#48e120"}
                loading={loading}
              />
            </div>
          </div>
        )}
        {listaOn && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">Seleccione a un Colaborador</span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    cerrarLista();
                  }}
                >
                  X
                </span>
              </div>
              <div className="cont-listnomi row">
                <div className="listnomi col-12">
                  <table className="tablanomi" border="1">
                    <thead className="theadcreartabla">
                      <tr className="trcreartabla">
                        {/* <th className="xtitunomina1">item.</th> */}
                        <th className="xtitunomina2">Documento.</th>
                        <th className="xtitunomina2">Nombre Colaborador.</th>
                        {/* <th className="xtitunomina1">Monto H/E.</th>
                        <th className="xtitunomina3">S.Quin.</th>
                        <th className="xtitunomina1">Dias N/T.</th>
                        <th className="xtitunomina1">Monto D/N/T.</th>
                        <th className="xtitunomina1">Horas N/T.</th>
                        <th className="xtitunomina1">Monto H/N/T.</th>
                        <th className="xtitunomina1">S.S.O.</th>
                        <th className="xtitunomina1">S.Edu.</th>
                        <th className="xtitunomina1">I.S.L.R.</th>
                        <th className="xtitunomina3">Sub-Total.</th>
                        <th className="xtitunomina3">Monto P.</th>
                        <th className="xtitunomina1">P.Pres.</th>
                        <th className="xtitunomina3">Total a Pagar.</th> */}
                        {/* <th className="xtitunomina1">
                          <span className="cerrarme3"></span>
                        </th> */}
                      </tr>
                    </thead>

                    <tbody className="evocuerpo1">
                      {personal.map((item, i) => {
                        return (
                          <tr
                            className={i % 2 === 0 ? "odd" : ""}
                            key={item.variable1}
                            id="tabla"
                          >
                            <td
                              width="20"
                              onClick={() => {
                                buscarPersonalI(item.variable2);
                              }}
                            >
                              {item.variable2}
                            </td>
                            <td
                              width="20"
                              onClick={() => {
                                buscarPersonalI(item.variable2);
                              }}
                            >
                              {item.variable3}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {paso === true && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-buscar1 row">
                <div
                  className="identificacionr2 col-12"
                  onClick={() => {
                    ClickUpload();
                  }}
                >
                  <p className="subirtexto1">
                    Haz click para adjuntar tus archivos
                  </p>
                  <br />
                  <FeatherIcon icon="upload" size="30px" stroke="#999" />
                  <input
                    onChange={Upload}
                    style={{ display: "none" }}
                    id="upload-file"
                    type="file"
                    multiple
                  />
                </div>
              </div>
              <div className="contenido1 row">
                <div className="form-groupef1 col-12">
                  <div className="preview row">
                    <div className="titulo-notificacion col-12">
                      <p>Archivos ya Guardados en el servidor.</p>
                    </div>
                    {irutas.map((item, i) => {
                      return (
                        <div className="cont-foto">
                          <span
                            className="cerrar"
                            onClick={() => {
                              eliarchivo(item.variable5);
                            }}
                          >
                            X
                          </span>{" "}
                          <a
                            href={
                              "https://institutobilinguelasnaciones.com/terapias/backend/" +
                              item.variable4
                            }
                            target="__blank"
                          >
                            {" "}
                            <img
                              src={
                                "https://institutobilinguelasnaciones.com/terapias/backend/" +
                                item.variable4
                              }
                              key={item.variable5}
                              alt={item.variable5}
                              className="fotos"
                              name={item.variable5}
                            />{" "}
                          </a>
                        </div>
                      );
                    })}
                  </div>

                  <div className="row">
                    <div className="titulo-notificacion col-12">
                      <p>{mensaje}</p>
                    </div>
                    <div className="accionesb col-12">
                      {/* <button className="boton" onClick={cerrarLista3}>
                        Cotejar
                      </button> */}
                      <button className="boton" onClick={cerrarLista2}>
                        Salir
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {verMasOn && (
          <div className="cont-vermas">
            <div className="panel-vermas">
              <div className="vermas-titulo">
                <span>Ver Mas +</span>
                <span className="vermas-cerrar" onClick={cerrarVerMas}>
                  X
                </span>
              </div>
              <div className="vermas-form row">
                <div className="vermas-campo col-7">
                  <label>
                    Descripcion.
                    <select
                      className="form-control"
                      value={verMasDesc}
                      onChange={(e) => setverMasDesc(e.target.value)}
                    >
                      <option value="">-- Descripcion --</option>
                      {CONCEPTOS_VER_MAS.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
                <div className="vermas-campo col-4">
                  <label>
                    Monto.
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Monto"
                      maxLength="12"
                      value={verMasMonto}
                      onChange={(e) => setverMasMonto(e.target.value)}
                    />
                  </label>
                </div>
              </div>
              <div className="vermas-radios">
                <label className="vermas-radio">
                  <input
                    type="radio"
                    name="verMasAplica"
                    checked={verMasAplica === "ESTA"}
                    onChange={() => setverMasAplica("ESTA")}
                  />
                  <span>
                    Esta
                    <br />
                    quincena
                  </span>
                </label>
                <label className="vermas-radio">
                  <input
                    type="radio"
                    name="verMasAplica"
                    checked={verMasAplica === "TODAS"}
                    onChange={() => setverMasAplica("TODAS")}
                  />
                  <span>
                    1ra y 2da
                    <br />
                    quincena
                  </span>
                </label>
              </div>
              <p className="vermas-ayuda">{textoAyudaVerMas(verMasAplica)}</p>
              <div className="vermas-acciones">
                <button className="boton" onClick={guardarVerMas}>
                  Guardar
                </button>
              </div>
              <div className="vermas-tabla-cont">
                <table className="vermas-tabla">
                  <thead>
                    <tr>
                      <th>Descripcion.</th>
                      <th>Monto.</th>
                      <th>Aplicacion.</th>
                      <th>Eliminar.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {verMasLista.map((item, i) => (
                      <tr key={item.variable1 || i}>
                        <td>{item.variable2}</td>
                        <td>{item.variable3}</td>
                        <td>{item.variable4}</td>
                        <td>
                          <button
                            className="vermas-eliminar"
                            onClick={() => eliminarVerMas(item.variable1)}
                          >
                            X
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {listaTnOn && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Nominas Creada a el Colaborador
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    cerrarListaTn();
                  }}
                >
                  X
                </span>
              </div>
              <span className="titulo-nomina"></span>

              <div className="cont-listnomi row">
                <div className="listnomi col-12">
                  <table className="tablanomi" border="1">
                    <thead className="theadcreartabla">
                      <tr className="trcreartabla">
                        {/* <th className="xtitunomina1">item.</th> */}
                        <th className="xtitunomina2x">Tipo de Nomina.</th>
                        <th className="xtitunomina2x">Tipo de Contrato.</th>
                        <th className="xtitunomina1x">Desactivada.</th>
                      </tr>
                    </thead>

                    <tbody className="evocuerpo1">
                      {nominaP.map((item, i) => {
                        return (
                          <tr
                            className={i % 2 === 0 ? "odd" : ""}
                            key={item.variable1}
                            id="tabla"
                          >
                            <td
                              className="nombrePersonalx"
                              width="20"
                              onClick={() => {
                                activarTN(item.variable1);
                              }}
                            >
                              {item.variable2}
                            </td>
                            <td
                              className="nombrePersonalx"
                              width="20"
                              onClick={() => {
                                activarTN(item.variable1);
                              }}
                            >
                              {item.variable3}
                            </td>

                            <td
                              className="nombrePersonalx"
                              width="20"
                              onClick={() => {
                                activarTN(item.variable1);
                              }}
                            >
                              {item.variable4}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {activarHOn && (
          <div className="cont-tablanominaHx row">
            <div className="tablanomina1 col-8">
              <div className="cont-titulomedi col-12">
                <span className="titulocasosHx">
                  Horario de Trabajo Especialistas.
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    activarH();
                  }}
                >
                  X
                </span>
              </div>

              <div className="cont-listnomiHx row">
                <div className="cont-opcioncas col-1">
                  <p className="tituloofertaH">LUNES.</p>
                  <input
                    className="horariochk"
                    type="checkbox"
                    name="lunesCheck"
                    id="lunesCheck"
                    value="SI"
                    checked={lunesCheck === "SI"}
                    onChange={onChange1}
                  />
                </div>

                <div className="cont-opcioncas col-1">
                  <p className="tituloofertaH">MARTES.</p>
                  <input
                    className="horariochk"
                    type="checkbox"
                    name="martesCheck"
                    id="martesCheck"
                    value="SI"
                    checked={martesCheck === "SI"}
                    onChange={onChange1}
                  />
                </div>
                <div className="cont-opcioncas col-1">
                  <p className="tituloofertaH">MIERCOLES.</p>
                  <input
                    className="horariochk"
                    type="checkbox"
                    name="miercolesCheck"
                    id="miercolesCheck"
                    value="SI"
                    checked={miercolesCheck === "SI"}
                    onChange={onChange1}
                  />
                </div>
                <div className="cont-opcioncas col-1">
                  <p className="tituloofertaH">JUEVES.</p>
                  <input
                    className="horariochk"
                    type="checkbox"
                    name="juevesCheck"
                    id="juevesCheck"
                    value="SI"
                    checked={juevesCheck === "SI"}
                    onChange={onChange1}
                  />
                </div>
                <div className="cont-opcioncas col-1">
                  <p className="tituloofertaH">VIERNES.</p>
                  <input
                    className="horariochk"
                    type="checkbox"
                    name="viernesCheck"
                    id="viernesCheck"
                    value="SI"
                    checked={viernesCheck === "SI"}
                    onChange={onChange1}
                  />
                </div>
                <div className="cont-opcioncas col-1">
                  <p className="tituloofertaH">SABADO.</p>
                  <input
                    className="horariochk"
                    type="checkbox"
                    name="sabadoCheck"
                    id="sabadoCheck"
                    value="SI"
                    checked={sabadoCheck === "SI"}
                    onChange={onChange1}
                  />
                </div>
              </div>

              <div className="cont-listnomiHx row">
                <div className="cont-personal col-3">
                  <label className="titulo-salario2x">
                    Hora de Entrada.
                    {/* <input
                      className="container"
                      type="time"
                      name="horaE1"
                      id="horaE1"
                      autoComplete="off"
                      onChange={onChange3}
                      value={typeof horaE1 !== "undefined" ? horaE1 : ""}
                    /> */}
                    <select
                      id="horaE1"
                      name="horaE1"
                      value={typeof horaE1 !== "undefined" ? horaE1 : ""}
                      onChange={onChange3}
                    >
                      <option value="">Hora de Salida.</option>
                      <option value="00:00:00">00:00</option>
                      <option value="07:00:00">07:00 am.</option>
                      <option value="08:00:00">08:00 am.</option>
                      <option value="09:00:00">09:00 am.</option>
                      <option value="10:00:00">10:00 am.</option>
                      <option value="11:00:00">11:00 am.</option>
                      <option value="12:00:00">12:00 am.</option>
                      <option value="13:00:00">01:00 pm.</option>
                      <option value="14:00:00">02:00 pm.</option>
                      <option value="15:00:00">03:00 pm.</option>
                      <option value="16:00:00">04:00 pm.</option>
                      <option value="17:00:00">05:00 pm.</option>
                      <option value="18:00:00">06:00 pm.</option>
                      <option value="19:00:00">07:00 pm.</option>
                    </select>
                  </label>
                </div>
                <div className="cont-personal col-3">
                  <label className="titulo-salario2x">
                    Hora de Salida.
                    {/* <input
                      className="container"
                      type="time"
                      name="horaS1"
                      id="horaS1"
                      autoComplete="off"
                      // placeholder="Hora de Salida 07:00 pm"
                      // maxLength="5"
                      onChange={onChange3}
                      value={typeof horaS1 !== "undefined" ? horaS1 : ""}
                    /> */}
                    <select
                      id="horaS1"
                      name="horaS1"
                      value={typeof horaS1 !== "undefined" ? horaS1 : ""}
                      onChange={onChange3}
                    >
                      <option value="">Hora de Salida.</option>
                      <option value="00:00:00">00:00</option>
                      <option value="07:00:00">07:00 am.</option>
                      <option value="08:00:00">08:00 am.</option>
                      <option value="09:00:00">09:00 am.</option>
                      <option value="10:00:00">10:00 am.</option>
                      <option value="11:00:00">11:00 am.</option>
                      <option value="12:00:00">12:00 am.</option>
                      <option value="13:00:00">01:00 pm.</option>
                      <option value="14:00:00">02:00 pm.</option>
                      <option value="15:00:00">03:00 pm.</option>
                      <option value="16:00:00">04:00 pm.</option>
                      <option value="17:00:00">05:00 pm.</option>
                      <option value="18:00:00">06:00 pm.</option>
                      <option value="19:00:00">07:00 pm.</option>
                    </select>
                  </label>
                </div>
              </div>
              <div className="cont-listnomiHx row">
                {fijoTerapiaCheck !== "SI" && (
                  <div className="cont-opcioncas col-2">
                    <p className="tituloofertaH">Personal Fijo.</p>
                    <input
                      className="horariochk"
                      type="checkbox"
                      name="fijoCheck"
                      id="fijoCheck"
                      value="SI"
                      checked={fijoCheck === "SI"}
                      onChange={onChange1}
                    />
                  </div>
                )}
                {fijoCheck === "SI" && (
                  <div className="cont-opcioncas col-2">
                    <p className="tituloofertaH">Per./Fijo C/Terapias.</p>
                    <input
                      className="horariochk"
                      type="checkbox"
                      name="fijoTerapiaCheck"
                      id="fijoTerapiaCheck"
                      value="SI"
                      checked={fijoTerapiaCheck === "SI"}
                      onChange={onChange1}
                    />
                  </div>
                )}
                <div className="cont-personal col-3">
                  <label className="titulo-salario2x">
                    Hora Tope Salida.{" "}
                    <select
                      id="horaTS1"
                      name="horaTS1"
                      value={typeof horaTS1 !== "undefined" ? horaTS1 : ""}
                      onChange={onChange3}
                    >
                      <option value="">Hora Tope Salida.</option>
                      <option value="13:00:00">01:00 pm.</option>
                      <option value="13:30:00">01:30 pm.</option>
                      <option value="14:00:00">02:00 pm.</option>
                      <option value="14:30:00">02:30 pm.</option>
                      <option value="15:00:00">03:00 pm.</option>
                      <option value="15:30:00">03:30 pm.</option>
                      <option value="16:00:00">04:00 pm.</option>
                      <option value="16:30:00">04:30 pm.</option>
                      <option value="17:00:00">05:00 pm.</option>
                      <option value="17:30:00">05:30 pm.</option>
                      <option value="18:00:00">06:00 pm.</option>
                      <option value="18:30:00">06:30 pm.</option>
                      <option value="19:00:00">07:00 pm.</option>
                      <option value="19:30:00">07:30 pm.</option>
                    </select>
                  </label>
                </div>
              </div>

              <div className="cont-listnomiHx row">
                <div className="cont-titulomedix col-12">
                  <span className="titulocasosx">Horario Libre</span>
                </div>
                <div className="cont-personal col-3">
                  <label className="titulo-salario2x">
                    Hora Inicio Libre.
                    <input
                      className="container"
                      type="time"
                      name="horaE2"
                      id="horaE2"
                      autoComplete="off"
                      placeholder="Hora Inicio Libre 07:00 am"
                      maxLength="5"
                      onChange={onChange3}
                      value={typeof horaE2 !== "undefined" ? horaE2 : ""}
                    />
                  </label>
                </div>
                <div className="cont-personal col-3">
                  <label className="titulo-salario2x">
                    Hora Final Libre.
                    <input
                      className="container"
                      type="time"
                      name="horaS2"
                      id="horaS2"
                      autoComplete="off"
                      placeholder="Hora Final Libre 07:00 pm"
                      maxLength="5"
                      onChange={onChange3}
                      value={typeof horaS2 !== "undefined" ? horaS2 : ""}
                    />
                  </label>
                </div>
                {/* </div> */}
                <div className="cont-personal col-12">
                  <button className="botonN" onClick={guardarHorario}>
                    Guardar Horario
                  </button>
                  <button className="boton" onClick={activarH}>
                    Salir
                  </button>
                </div>
              </div>
              <div className="row">
                {/* <div className=" col-12"> */}
                <div className="cont-dias col-2">
                  <span className="titulocasosx">Lunes</span>
                </div>
                <div className="cont-dias col-2">
                  <span className="titulocasosx">Martes</span>
                </div>
                <div className="cont-dias col-2">
                  <span className="titulocasosx">Miercoles</span>
                </div>
                <div className="cont-dias col-2">
                  <span className="titulocasosx">Jueves</span>
                </div>
                <div className="cont-dias col-2">
                  <span className="titulocasosx">Viernes</span>
                </div>
                <div className="cont-dias col-2">
                  <span className="titulocasosx">Sabado</span>
                </div>
                <div className=" col-1">H/Entrada</div>
                <div className=" col-1">H/Salida</div>
                <div className=" col-1">H/Entrada</div>
                <div className=" col-1">H/Salida</div>
                <div className=" col-1">H/Entrada</div>
                <div className=" col-1">H/Salida</div>
                <div className=" col-1">H/Entrada</div>
                <div className=" col-1">H/Salida</div>
                <div className=" col-1">H/Entrada</div>
                <div className=" col-1">H/Salida</div>
                <div className=" col-1">H/Entrada</div>
                <div className=" col-1">H/Salida</div>
                <div className="titulocasosx col-1">{tiempoE1}</div>
                <div className="titulocasosx col-1">{tiempoS1}</div>
                <div className="titulocasosx col-1">{tiempoE2}</div>
                <div className="titulocasosx col-1">{tiempoS2}</div>
                <div className="titulocasosx col-1">{tiempoE3}</div>
                <div className="titulocasosx col-1">{tiempoS3}</div>
                <div className="titulocasosx col-1">{tiempoE4}</div>
                <div className="titulocasosx col-1">{tiempoS4}</div>
                <div className="titulocasosx col-1">{tiempoE5}</div>
                <div className="titulocasosx col-1">{tiempoS5}</div>
                <div className="titulocasosx col-1">{tiempoE6}</div>
                <div className="titulocasosx col-1">{tiempoS6}</div>
              </div>
            </div>
            {/* </div> */}
          </div>
        )}

        {listaDatosBOn && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <label className="titulo-salario2">
                    Quincena a consultar.
                    <select
                      id="trimestre"
                      name="trimestre"
                      value={typeof trimestre !== "undefined" ? trimestre : ""}
                      onChange={onChange}
                    >
                      <option value="0">Seleccione Quincena</option>
                      <option value="1">Primera Quincena.</option>
                      <option value="2">Segunda Quincena.</option>
                    </select>
                  </label>
                </div>
                <div className="cont-personal col-2">
                  <label className="titulo-salario2">
                    Mes a Pagar.
                    <select
                      id="mesapagar"
                      name="mesapagar"
                      value={typeof mesapagar !== "undefined" ? mesapagar : ""}
                      onChange={onChange}
                    >
                      <option value="0">Mes a Pagar</option>
                      {mes.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </label>
                </div>
                <div className="cont-personal col-2">
                  <label className="titulo-salario2">
                    Año a Pagar.
                    <select
                      id="anopagar"
                      name="anopagar"
                      value={typeof anopagar !== "undefined" ? anopagar : ""}
                      onChange={onChange}
                    >
                      <option value="0">Año a Pagar</option>
                      {anio.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable1}
                          </option>
                        );
                      })}
                    </select>
                  </label>
                </div>
              </div>

              <div className="cont-personal col-12">
                <button className="botonN" onClick={datosBanco}>
                  Generar Reporte
                </button>
                <button className="boton" onClick={cerrarListaDatosB}>
                  Salir
                </button>
              </div>
            </div>
          </div>
        )}

        {listaSuOn && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Empleados Suspendidos o Retirados
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    cerrarListaSu();
                  }}
                >
                  X
                </span>
              </div>
              <span className="titulo-nomina"></span>

              <div className="cont-listnomi row">
                <div className="listnomi col-12">
                  <table className="tablanomi" border="1">
                    <thead className="theadcreartabla">
                      <tr className="trcreartabla">
                        <th className="xtitunomina2x">Documento.</th>
                        <th className="xtitunomina2x">Trabajador.</th>
                        <th className="xtitunomina1x">Estatus.</th>
                      </tr>
                    </thead>

                    <tbody className="evocuerpo1">
                      {nominaPS.map((item, i) => {
                        return (
                          <tr
                            className={i % 2 === 0 ? "odd" : ""}
                            key={item.variable1}
                            id="tabla"
                          >
                            <td
                              className="nombrePersonalx"
                              width="20"
                              onClick={() => {
                                buscarPersonal(item.variable2);
                              }}
                            >
                              {item.variable2}
                            </td>
                            <td
                              className="nombrePersonalx"
                              width="20"
                              onClick={() => {
                                buscarPersonal(item.variable2);
                              }}
                            >
                              {item.variable3}
                            </td>
                            <td
                              className="nombrePersonalx"
                              width="20"
                              onClick={() => {
                                buscarPersonal(item.variable2);
                              }}
                            >
                              {item.variable4}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {!aprobarOn && (
          <div>
            <div className="cont-listmedi row">
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Cedula Empleado.
                  <input
                    className="form-control"
                    type="text"
                    name="cedula"
                    id="cedula"
                    readOnly={!activarOn ? "" : "readonly"}
                    autoComplete="off"
                    placeholder="Cedula Empleado"
                    maxLength="15"
                    onChange={onChange}
                    value={
                      typeof data.cedula !== "undefined"
                        ? data.cedula.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Nombre Empleado.
                  <input
                    className="form-control"
                    type="text"
                    name="nombre"
                    id="nombre"
                    autoComplete="off"
                    placeholder="Nombre"
                    maxLength="120"
                    onChange={onChange}
                    value={
                      typeof data.nombre !== "undefined"
                        ? data.nombre.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Apellido Empleado.
                  <input
                    className="form-control"
                    type="text"
                    name="apellido"
                    id="apellido"
                    autoComplete="off"
                    placeholder="Apellido"
                    maxLength="120"
                    onChange={onChange}
                    value={
                      typeof data.apellido !== "undefined"
                        ? data.apellido.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Fecha Naci.
                  <input
                    className="form-control"
                    type="date"
                    name="fechaNaci"
                    id="fechaNaci"
                    autoComplete="off"
                    maxLength="10"
                    onChange={onChange}
                    value={
                      typeof data.fechaNaci !== "undefined"
                        ? data.fechaNaci
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-1">
                <label className="titulo-salario2">
                  Edad.
                  <input
                    className="form-control"
                    type="text"
                    name="edad"
                    id="edad"
                    autoComplete="off"
                    placeholder="Edad"
                    maxLength="3"
                    onChange={onChange}
                    value={typeof data.edad !== "undefined" ? data.edad : ""}
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Correo Emp.
                  <input
                    className="form-control"
                    type="text"
                    name="correo"
                    id="correo"
                    autoComplete="off"
                    placeholder="Correo Emp."
                    maxLength="50"
                    onChange={onChange}
                    value={
                      typeof data.correo !== "undefined"
                        ? data.correo.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
            </div>
            <div className="cont-listmedi row">
              <div className="cont-personal col-3">
                <input
                  className="form-control"
                  type="text"
                  name="direccion"
                  id="direccion"
                  autoComplete="off"
                  placeholder="Dirección."
                  maxLength="50"
                  onChange={onChange}
                  value={
                    typeof data.direccion !== "undefined"
                      ? data.direccion.toUpperCase()
                      : ""
                  }
                />
              </div>

              <div className="cont-personal col-3">
                <label className="titulo-salario2">
                  {/* Nombre Dependiente 1. */}
                  <input
                    className="form-control"
                    type="text"
                    name="nombreD1"
                    id="nombreD1"
                    autoComplete="off"
                    placeholder="Nombre Dependiente 1."
                    maxLength="100"
                    onChange={onChange}
                    value={
                      typeof data.nombreD1 !== "undefined"
                        ? data.nombreD1.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-1">
                <label className="titulo-salario2">
                  {/* Edad Dependiente. */}
                  <input
                    className="form-control"
                    type="text"
                    name="edadD1"
                    id="edadD1"
                    autoComplete="off"
                    placeholder="Edad."
                    maxLength="3"
                    onChange={onChange}
                    value={
                      typeof data.edadD1 !== "undefined"
                        ? data.edadD1.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-3">
                <label className="titulo-salario2">
                  {/* Parentesco. */}
                  <input
                    className="form-control"
                    type="text"
                    name="parentescoD1"
                    id="parentescoD1"
                    autoComplete="off"
                    placeholder="Parentesco."
                    maxLength="25"
                    onChange={onChange}
                    value={
                      typeof data.parentescoD1 !== "undefined"
                        ? data.parentescoD1.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="accionesb col-1">
                {btnnoauto1On === "SI" ? (
                  <button className="botonem" onClick={botonnoautorizado}>
                    -
                  </button>
                ) : (
                  <button className="botonem" onClick={botonnoautorizado}>
                    +
                  </button>
                )}
              </div>
            </div>
            {btnnoauto1On === "SI" && (
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <label className="titulo-salario2">
                    {/* Nombre Dependiente 2. */}
                    <input
                      className="form-control"
                      type="text"
                      name="nombreD2"
                      id="nombreD2"
                      autoComplete="off"
                      placeholder="Nombre Dependiente 2."
                      maxLength="100"
                      onChange={onChange}
                      value={
                        typeof data.nombreD2 !== "undefined"
                          ? data.nombreD2.toUpperCase()
                          : ""
                      }
                    />
                  </label>
                </div>
                <div className="cont-personal col-1">
                  <label className="titulo-salario2">
                    {/* Edad Dependiente. */}
                    <input
                      className="form-control"
                      type="text"
                      name="edadD2"
                      id="edadD2"
                      autoComplete="off"
                      placeholder="Edad."
                      maxLength="3"
                      onChange={onChange}
                      value={
                        typeof data.edadD2 !== "undefined"
                          ? data.edadD2.toUpperCase()
                          : ""
                      }
                    />
                  </label>
                </div>
                <div className="cont-personal col-3">
                  <label className="titulo-salario2">
                    {/* Parentesco. */}
                    <input
                      className="form-control"
                      type="text"
                      name="parentescoD2"
                      id="parentescoD2"
                      autoComplete="off"
                      placeholder="Parentesco."
                      maxLength="25"
                      onChange={onChange}
                      value={
                        typeof data.parentescoD2 !== "undefined"
                          ? data.parentescoD2.toUpperCase()
                          : ""
                      }
                    />
                  </label>
                </div>
                <div className="accionesb col-1">
                  {btnnoauto2On === "SI" ? (
                    <button className="botonem" onClick={botonnoautorizado2}>
                      -
                    </button>
                  ) : (
                    <button className="botonem" onClick={botonnoautorizado2}>
                      +
                    </button>
                  )}
                </div>
              </div>
            )}
            {btnnoauto2On === "SI" && (
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <label className="titulo-salario2">
                    {/* Nombre Dependiente 3. */}
                    <input
                      className="form-control"
                      type="text"
                      name="nombreD3"
                      id="nombreD3"
                      autoComplete="off"
                      placeholder="Nombre Dependiente 3."
                      maxLength="100"
                      onChange={onChange}
                      value={
                        typeof data.nombreD3 !== "undefined"
                          ? data.nombreD3.toUpperCase()
                          : ""
                      }
                    />
                  </label>
                </div>
                <div className="cont-personal col-1">
                  <label className="titulo-salario2">
                    {/* Edad Dependiente. */}
                    <input
                      className="form-control"
                      type="text"
                      name="edadD3"
                      id="edadD3"
                      autoComplete="off"
                      placeholder="Edad."
                      maxLength="3"
                      onChange={onChange}
                      value={
                        typeof data.edadD3 !== "undefined"
                          ? data.edadD3.toUpperCase()
                          : ""
                      }
                    />
                  </label>
                </div>
                <div className="cont-personal col-3">
                  <label className="titulo-salario2">
                    {/* Parentesco. */}
                    <input
                      className="form-control"
                      type="text"
                      name="parentescoD3"
                      id="parentescoD3"
                      autoComplete="off"
                      placeholder="Parentesco."
                      maxLength="30"
                      onChange={onChange}
                      value={
                        typeof data.parentescoD3 !== "undefined"
                          ? data.parentescoD3.toUpperCase()
                          : ""
                      }
                    />
                  </label>
                </div>
              </div>
            )}
            <div className="cont-listmedi row">
              <div className="cont-personal col-4">
                <label className="titulo-salario2">
                  Profesion Empleado.
                  <select
                    id="profesion"
                    name="profesion"
                    value={data.profesion || ""}
                    onChange={onChange}
                  >
                    <option value="">-- Profesion --</option>
                    {profesiones.map(function (nombre) {
                      return (
                        <option key={nombre} value={nombre}>
                          {nombre}
                        </option>
                      );
                    })}
                  </select>
                </label>
              </div>
              <div className="cont-personal col-3">
                <label className="titulo-salario2">
                  Nacionalidad.
                  <input
                    className="form-control"
                    type="text"
                    name="nacionalidad"
                    id="nacionalidad"
                    autoComplete="off"
                    placeholder="Nacionalidad."
                    maxLength="30"
                    onChange={onChange}
                    value={
                      typeof data.nacionalidad !== "undefined"
                        ? data.nacionalidad.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Estado Civil.
                  <select
                    id="edocivil"
                    name="edocivil"
                    value={data.edocivil}
                    onChange={onChange}
                  >
                    <option value="0">-- Estado Civil --</option>
                    <option value="1">Soltero(a).</option>
                    <option value="2">Casado(a).</option>
                    <option value="3">Unido(a).</option>
                    <option value="4">Viudo(a).</option>
                  </select>
                </label>
              </div>
              <div className="cont-personal col-3">
                <label className="titulo-salario2">
                  Telefono.
                  <input
                    className="form-control"
                    type="text"
                    name="telefono"
                    id="telefono"
                    autoComplete="off"
                    placeholder="Telefono."
                    maxLength="130"
                    onChange={onChange}
                    value={
                      typeof data.telefono !== "undefined"
                        ? data.telefono.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
            </div>
            <div className="cont-listmedi row">
              {(data.pagoExiste !== "1" || data.pagoTransferencia === "1") && (
                <div className="cont-personal col-12">
                  <p className="titulo-tipo-pago">Transferencia</p>
                </div>
              )}
              <div className="cont-personal col-2">
                <label className="titulo-salario">
                  Número de Cuenta
                  <input
                    className="form-control"
                    type="text"
                    name="cuenta"
                    id="cuenta"
                    autoComplete="off"
                    placeholder="Cuenta del Banco"
                    maxLength="30"
                    onChange={onChange}
                    value={
                      typeof data.cuenta !== "undefined"
                        ? data.cuenta.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario">
                  Nombre del Banco
                  <input
                    className="form-control"
                    type="text"
                    name="banco1"
                    id="banco1"
                    autoComplete="off"
                    placeholder="Nombre del Banco"
                    maxLength="30"
                    onChange={onChange}
                    value={
                      typeof data.banco1 !== "undefined"
                        ? data.banco1.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario">
                  Tipo de Cuenta
                  <input
                    className="form-control"
                    type="text"
                    name="tcuenta"
                    id="tcuenta"
                    autoComplete="off"
                    placeholder="Tipo de Cuenta"
                    maxLength="30"
                    onChange={onChange}
                    value={
                      typeof data.tcuenta !== "undefined"
                        ? data.tcuenta.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario">
                  Titular Cuenta
                  <input
                    className="form-control"
                    type="text"
                    name="titular"
                    id="titular"
                    autoComplete="off"
                    placeholder="Titular Cuenta"
                    maxLength="30"
                    onChange={onChange}
                    value={
                      typeof data.titular !== "undefined"
                        ? data.titular.toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
            </div>
            {data.pagoExiste === "1" &&
              (data.pagoYappy === "1" ||
                data.pagoWestern === "1" ||
                data.pagoEfectivo === "1" ||
                data.pagoOtro === "1") && (
                <div className="cont-listmedi row">
                  {data.pagoYappy === "1" && (
                    <div className="cont-personal col-12">
                      <p className="titulo-tipo-pago">Yappy</p>
                      <div className="cont-listmedi row">
                        <div className="cont-personal col-4">
                          <label className="titulo-salario">
                            Nombre del titular
                            <input
                              className="form-control"
                              type="text"
                              id="yappyNombre"
                              maxLength="200"
                              onChange={onChange}
                              value={data.yappyNombre || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-3">
                          <label className="titulo-salario">
                            Número asociado
                            <input
                              className="form-control"
                              type="text"
                              id="yappyNumero"
                              maxLength="40"
                              onChange={onChange}
                              value={data.yappyNumero || ""}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  {data.pagoWestern === "1" && (
                    <div className="cont-personal col-12">
                      <p className="titulo-tipo-pago">Western Union</p>
                      <div className="cont-listmedi row">
                        <div className="cont-personal col-4">
                          <label className="titulo-salario">
                            Nombre del beneficiario
                            <input
                              className="form-control"
                              type="text"
                              id="westernBeneficiario"
                              maxLength="200"
                              onChange={onChange}
                              value={data.westernBeneficiario || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-3">
                          <label className="titulo-salario">
                            Cédula o pasaporte
                            <input
                              className="form-control"
                              type="text"
                              id="westernDocumento"
                              maxLength="80"
                              onChange={onChange}
                              value={data.westernDocumento || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-3">
                          <label className="titulo-salario">
                            País donde recibe
                            <input
                              className="form-control"
                              type="text"
                              id="westernPais"
                              maxLength="120"
                              onChange={onChange}
                              value={data.westernPais || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-3">
                          <label className="titulo-salario">
                            Ciudad
                            <input
                              className="form-control"
                              type="text"
                              id="westernCiudad"
                              maxLength="120"
                              onChange={onChange}
                              value={data.westernCiudad || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-3">
                          <label className="titulo-salario">
                            Teléfono
                            <input
                              className="form-control"
                              type="text"
                              id="westernTelefono"
                              maxLength="40"
                              onChange={onChange}
                              value={data.westernTelefono || ""}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  {data.pagoEfectivo === "1" && (
                    <div className="cont-personal col-12">
                      <p className="titulo-tipo-pago">Efectivo</p>
                    </div>
                  )}
                  {data.pagoOtro === "1" && (
                    <div className="cont-personal col-12">
                      <p className="titulo-tipo-pago">Otro</p>
                      <div className="cont-listmedi row">
                        <div className="cont-personal col-6">
                          <label className="titulo-salario">
                            Descripción
                            <input
                              className="form-control"
                              type="text"
                              id="otroDescripcion"
                              maxLength="120"
                              onChange={onChange}
                              value={data.otroDescripcion || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-6">
                          <label className="titulo-salario">
                            Método
                            <input
                              className="form-control"
                              type="text"
                              id="otroMetodo"
                              maxLength="120"
                              onChange={onChange}
                              value={data.otroMetodo || ""}
                            />
                          </label>
                        </div>
                        <div className="cont-personal col-12">
                          <label className="titulo-salario">
                            Datos necesarios para realizar el pago
                            <textarea
                              className="form-control"
                              id="otroDatos"
                              maxLength="2000"
                              rows="3"
                              onChange={onChange}
                              value={data.otroDatos || ""}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
          </div>
        )}
        {aprobarOn && (
          <div className="cont-listmedi row">
            <div className="datos-adm-css-fila col-12 row">
              <div className="cont-personal col-3">
                <label className="titulo-salario">
                  Tipo Documento.
                  <select
                    className="form-control"
                    id="tipoDocumento"
                    name="tipoDocumento"
                    value={data.tipoDocumento || "CEDULA"}
                    onChange={onChange}
                  >
                    <option value="CEDULA">Cedula</option>
                    <option value="PASAPORTE">Pasaporte</option>
                  </select>
                </label>
              </div>
              <div className="cont-personal col-2">
                <label className="titulo-salario">
                  DV.
                  <input
                    className="form-control"
                    type="text"
                    name="dv"
                    id="dv"
                    autoComplete="off"
                    placeholder="DV"
                    maxLength="4"
                    inputMode="numeric"
                    onChange={onChange}
                    value={typeof data.dv !== "undefined" ? data.dv : ""}
                  />
                </label>
              </div>
              <div className="cont-personal col-4">
                <label className="titulo-salario">
                  Numero SSO.
                  <input
                    className="form-control"
                    type="text"
                    name="numeroSso"
                    id="numeroSso"
                    autoComplete="off"
                    placeholder="Numero SSO"
                    maxLength="30"
                    onChange={onChange}
                    value={
                      typeof data.numeroSso !== "undefined"
                        ? String(data.numeroSso).toUpperCase()
                        : ""
                    }
                  />
                </label>
              </div>
            </div>
            <div className="cont-personal col-3">
              <label className="titulo-salario">
                Cargo Empleado.
                <input
                  className="form-control"
                  type="text"
                  name="cargo"
                  id="cargo"
                  autoComplete="off"
                  placeholder="Cargo del Empleado"
                  maxLength="25"
                  onChange={onChange}
                  value={
                    typeof data.cargo !== "undefined"
                      ? data.cargo.toUpperCase()
                      : ""
                  }
                />
              </label>
            </div>
            <div className="cont-personal col-2">
              <label className="titulo-salario">
                Fecha Ingreso.
                <input
                  className="form-control"
                  type="date"
                  name="fechaIngreso"
                  id="fechaIngreso"
                  autoComplete="off"
                  maxLength="10"
                  onChange={onChange}
                  value={
                    typeof data.fechaIngreso !== "undefined"
                      ? data.fechaIngreso
                      : ""
                  }
                />
              </label>
            </div>
            <div className="cont-personal col-2">
              <label className="titulo-salario">
                Fecha Egreso.
                <input
                  className="form-control"
                  type="date"
                  name="fechaEgreso"
                  id="fechaEgreso"
                  autoComplete="off"
                  maxLength="10"
                  onChange={onChange}
                  value={
                    typeof data.fechaEgreso !== "undefined"
                      ? data.fechaEgreso
                      : ""
                  }
                />
              </label>
            </div>
            <div className="cont-personal col-3">
              <label className="titulo-salario">
                Tipo Nomina.
                <select
                  id="tiponomina"
                  name="tiponomina"
                  value={data.tiponomina}
                  onChange={onChange2}
                >
                  <option value="0">-- Tipo de Nomina --</option>
                  {/* <option value="1">
                    Colaboradores con Deducciones Definido.
                  </option>
                  <option value="2">
                    Colaboradores con Deducciones Indefinido.
                  </option> */}
                  <option value="3">Honorario Profesionales.</option>
                  <option value="5">Contrato Por Hora Definido.</option>
                  <option value="6">Contrato Por Hora Indefinido.</option>
                </select>
              </label>
            </div>
            <div className="cont-personal col-2">
              <label className="titulo-salario2">
                Tipo de Contrato.
                <select
                  id="tcontrato"
                  name="tcontrato"
                  value={data.tcontrato}
                  onChange={onChange}
                >
                  {opcionesTipoContrato().map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
        )}
        {aprobarOn && (
          <div className="cont-listmedi row">
            {/* <div className="contenedorcedulaC col-3">
              <label className="titulo-salario2">
                C/Contable.
                <select
                  id="cuentaContable2"
                  name="cuentaContable2"
                  value={data.cuentaContable2}
                  onChange={onChange}
                >
                  <option>Cuenta Contable</option>

                  {cuentaC.map((item, i) => {
                    return (
                      <option value={item.variable2}>
                        {item.variable6 + " - " + item.variable3}{" "}
                      </option>
                    );
                  })}
                </select>
              </label>
            </div> */}
            <div className="cont-personal col-2">
              <label className="titulo-salario2">
                Sede.
                <select
                  id="sede"
                  name="sede"
                  value={data.sede}
                  onChange={onChange}
                >
                  <option>-Seleccione Sucursal-</option>
                  {sedes.map((item) => (
                    <option key={item.variable1} value={String(item.variable1)}>
                      {item.variable2}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            {(parseFloat(
              String(data.primaProduccion || "").replace(",", ".")
            ) || 0) > 0 && (
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Prima parte Decimo.
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={data.primaParteDecimo === "S"}
                    onChange={onChangePrimaParteDecimo}
                  />
                </label>
              </div>
            )}
            <div className="cont-personal col-2">
              <label className="titulo-salario2">
                Status Adm.
                <select
                  id="statusA"
                  name="statusA"
                  value={data.statusA}
                  onChange={onChange}
                >
                  <option value="0">-Status Adm.-</option>
                  <option value="1">Activo.</option>
                  <option value="2">Suspendido.</option>
                  <option value="3">Retirado.</option>
                </select>
              </label>
            </div>
            {data.tiponomina === "3" && (
              <div className="cont-personal col-2">
                <label className="titulo-salario2">
                  Activar Decimo.
                  <select
                    id="statusDe"
                    name="statusDe"
                    value={data.statusDe}
                    onChange={onChange}
                  >
                    <option>-Status Decimo-</option>
                    <option value="1">Activo</option>
                    <option value="2">No Activo</option>
                  </select>
                </label>
              </div>
            )}
            {esContratoOperativo(data.tiponomina, data.tcontrato) && (
              <div className="cont-personal pago-operativo-bloque">
                <label className="titulo-salario2 pago-operativo-check">
                  Pago Unico.
                  <input
                    type="checkbox"
                    checked={tienePagoUnicoOperativo(data.tcontratoOperativo)}
                    onChange={() => onToggleOperativo(1)}
                  />
                </label>
                <label className="titulo-salario2 pago-operativo-check">
                  Por Terapia.
                  <input
                    type="checkbox"
                    checked={tienePorTerapiaOperativo(data.tcontratoOperativo)}
                    onChange={() => onToggleOperativo(2)}
                  />
                </label>
              </div>
            )}
            <div className="cont-listmedi row">
              <div className="titulo-cxc1 col-5 ">
                <p className="confi">CONFIGURAR ASIGNACIONES. </p>
              </div>
              <div className="col-1">
                <p></p>
              </div>
              <div className="titulo-cxc1 col-5 ">
                <p className="confi">CONFIGURAR DEDUCCIONES. </p>
              </div>
            </div>
            <div className="cont-listmedi row">
              <div className="cont-personal col-6">
                <div className="cont-listmedi row asignaciones-salario-horas-prima">
                  <div className="cont-personal col-4">
                    <label className="titulo-salario">
                      Salario Base.
                      <input
                        className="form-control"
                        type="text"
                        name="salarioBaseMensual"
                        id="salarioBaseMensual"
                        autoComplete="off"
                        placeholder="Salario Base"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.salarioBaseMensual !== "undefined"
                            ? data.salarioBaseMensual
                            : ""
                        }
                      />
                    </label>
                  </div>
                  <div className="cont-personal col-4">
                    <label className="titulo-salario">
                      Horas Diarias.
                      <input
                        className="form-control"
                        type="text"
                        name="horasDiaria"
                        id="horasDiaria"
                        autoComplete="off"
                        placeholder="Horas Diarias"
                        maxLength="5"
                        onChange={onChange}
                        value={
                          typeof data.horasDiaria !== "undefined"
                            ? data.horasDiaria
                            : ""
                        }
                      />
                    </label>
                  </div>
                  <div className="cont-personal col-4">
                    <label className="titulo-salario">
                      Prima producción.
                      <input
                        className="form-control"
                        type="text"
                        name="primaProduccion"
                        id="primaProduccion"
                        autoComplete="off"
                        placeholder="Prima producción"
                        onChange={onChange}
                        value={
                          typeof data.primaProduccion !== "undefined"
                            ? data.primaProduccion
                            : ""
                        }
                      />
                    </label>
                  </div>
                </div>
                <div className="cont-listmedi row">
                  <div className="cont-personal col-5">
                    <label className="titulo-salario">
                      Dias Semanal.
                      <input
                        className="form-control"
                        type="text"
                        name="diasSemanal"
                        id="diasSemanal"
                        autoComplete="off"
                        placeholder="Dias Semanal"
                        maxLength="5"
                        onChange={onChange}
                        value={
                          typeof data.diasSemanal !== "undefined"
                            ? data.diasSemanal
                            : ""
                        }
                      />
                    </label>
                  </div>
                  <div className="cont-personal col-5">
                    <button className="botonN" onClick={calcular}>
                      Calcular Salario
                    </button>
                  </div>
                </div>

                <div className="cont-listmedi row asignaciones-salario-desglose">
                  <div className="cont-personal col-3">
                    <label className="titulo-salario">
                      Salario/hora.
                      <input
                        className="form-control"
                        type="text"
                        name="salarioHora"
                        id="salarioHora"
                        readOnly="readonly"
                        autoComplete="off"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.salarioHora !== "undefined"
                            ? data.salarioHora
                            : ""
                        }
                      />
                    </label>
                  </div>
                  <div className="cont-personal col-3">
                    <label className="titulo-salario">
                      Salario/Dia.
                      <input
                        className="form-control"
                        type="text"
                        name="salarioDia"
                        id="salarioDia"
                        readOnly="readonly"
                        autoComplete="off"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.salarioDia !== "undefined"
                            ? data.salarioDia
                            : ""
                        }
                      />
                    </label>
                  </div>
                  <div className="cont-personal col-3">
                    <label className="titulo-salario">
                      Quincena.
                      <input
                        className="form-control"
                        type="text"
                        name="salarioQuincenal"
                        id="salarioQuincenal"
                        readOnly="readonly"
                        autoComplete="off"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.salarioQuincenal !== "undefined"
                            ? data.salarioQuincenal
                            : ""
                        }
                      />
                    </label>
                  </div>
                </div>

                <div className="cont-listmedi row asignaciones-prima-desglose">
                  <div className="cont-personal col-3">
                    <div className="asignaciones-prima-desglose-hora">
                      <span className="titulo-salario asignaciones-prima-etiqueta">
                        P/Producc.
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        name="salarioHoraPrima"
                        id="salarioHoraPrima"
                        readOnly="readonly"
                        autoComplete="off"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.salarioHoraPrima !== "undefined"
                            ? data.salarioHoraPrima
                            : ""
                        }
                      />
                    </div>
                  </div>
                  <div className="cont-personal col-3">
                    <input
                      className="form-control"
                      type="text"
                      name="salarioDiaPrima"
                      id="salarioDiaPrima"
                      readOnly="readonly"
                      autoComplete="off"
                      maxLength="10"
                      onChange={onChange}
                      value={
                        typeof data.salarioDiaPrima !== "undefined"
                          ? data.salarioDiaPrima
                          : ""
                      }
                    />
                  </div>
                  <div className="cont-personal col-3">
                    <input
                      className="form-control"
                      type="text"
                      name="salarioQuincenalPrima"
                      id="salarioQuincenalPrima"
                      readOnly="readonly"
                      autoComplete="off"
                      maxLength="10"
                      onChange={onChange}
                      value={
                        typeof data.salarioQuincenalPrima !== "undefined"
                          ? data.salarioQuincenalPrima
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="cont-personal col-6">
                <div className="cont-listmedi row">
                  <div className="cont-personal col-5">
                    <label className="titulo-salario">
                      S. Social.
                      <input
                        className="form-control"
                        type="text"
                        name="sso"
                        id="sso"
                        readOnly={
                          data.tiponomina === "1" ||
                          data.tiponomina === "2" ||
                          data.tiponomina === "5" ||
                          data.tiponomina === "6"
                            ? ""
                            : "readonly"
                        }
                        autoComplete="off"
                        placeholder="S.Social"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.sso !== "undefined" || data.sso === "0"
                            ? data.tiponomina === "1" ||
                              data.tiponomina === "2" ||
                              data.tiponomina === "5" ||
                              data.tiponomina === "6"
                              ? xsso
                              : ""
                            : ""
                        }
                      />
                    </label>
                  </div>
                  <div className="cont-personal col-5">
                    <label className="titulo-salario">
                      SSO XIII MES.
                      <input
                        className="form-control"
                        type="text"
                        name="ssoDecimo"
                        id="ssoDecimo"
                        readOnly={
                          data.tiponomina === "1" ||
                          data.tiponomina === "2" ||
                          data.tiponomina === "5" ||
                          data.tiponomina === "6"
                            ? ""
                            : "readonly"
                        }
                        autoComplete="off"
                        placeholder="SSO XIII MES"
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.ssoDecimo !== "undefined" ||
                          data.ssoDecimo === "0"
                            ? data.tiponomina === "1" ||
                              data.tiponomina === "2" ||
                              data.tiponomina === "5" ||
                              data.tiponomina === "6"
                              ? xssoDecimo
                              : ""
                            : ""
                        }
                      />
                    </label>
                  </div>
                </div>
                <div className="cont-listmedi row">
                  <div className="cont-personal col-5">
                    <label className="titulo-salario">
                      Seguro Educativo.
                      <input
                        className="form-control"
                        type="text"
                        name="seguroEducativo"
                        id="seguroEducativo"
                        readOnly={
                          data.tiponomina === "1" ||
                          data.tiponomina === "2" ||
                          data.tiponomina === "5" ||
                          data.tiponomina === "6"
                            ? ""
                            : "readonly"
                        }
                        autoComplete="off"
                        placeholder="Seguro Educ."
                        maxLength="10"
                        onChange={onChange}
                        value={
                          typeof data.seguroEducativo !== "undefined" ||
                          data.seguroEducativo === "0"
                            ? data.tiponomina === "1" ||
                              data.tiponomina === "2" ||
                              data.tiponomina === "5" ||
                              data.tiponomina === "6"
                              ? xseguroEducativo
                              : ""
                            : ""
                        }
                      />
                    </label>
                  </div>
                </div>
                <div
                  className="cont-listmedi row"
                  style={{
                    border: "2px solid #dc3545",
                    borderRadius: "6px",
                    margin: "8px 4px",
                    padding: "6px 4px",
                  }}
                >
                  <div className="cont-personal col-5">
                    <label className="titulo-salario" style={{ color: "#dc3545" }}>
                      Opción impresión en reportes.
                      <select
                        id="diaImpresionReporte"
                        name="diaImpresionReporte"
                        className="form-control"
                        value={
                          typeof data.diaImpresionReporte !== "undefined"
                            ? data.diaImpresionReporte
                            : ""
                        }
                        onChange={onChange}
                      >
                        <option value="">Seleccione opción</option>
                        <option value="1">Opción 1 (15 y 30)</option>
                        <option value="2">Opción 2 (5 y 20)</option>
                        <option value="3">Opción 3 (10 y 25)</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!aprobarOn && (
          <div className="contenedorcedula1 col-12">
            {(!activarOn || data.aprobado === "SI") && (
              <button
                className={!activarOn ? "boton" : "botoncp"}
                onClick={!activarOn ? guardarEmpleado : ""}
              >
                Guardar Empleado
              </button>
            )}
            {activarOn && (
              <button className="boton" onClick={modificarEmpleado}>
                Modificar Empleado
              </button>
            )}
            {activarOn &&
              data.aprobado === "SI" &&
              props.usuario1.nivel !== "2" && (
                <button className="boton" onClick={eliminarEmpleado}>
                  Eliminar Empleado
                </button>
              )}
            <button className="boton" onClick={cerrarLista}>
              Buscar Colaborador
            </button>
            {activarOn &&
              data.aprobado === "SI" &&
              props.usuario1.nivel !== "2" && (
                <button className="boton" onClick={consultarAdjuntos}>
                  Requisitos Colaborador
                </button>
              )}
            {activarOn && (
              <button className="boton" onClick={datosADM}>
                Datos Administrativo
              </button>
            )}
            <button className="boton" onClick={limpiar}>
              Limpiar Datos
            </button>
            <button className="boton" onClick={props.personalClose}>
              Salir
            </button>
          </div>
        )}
        {aprobarOn && (
          <div className="contenedorcedula1 col-12">
            <button
              className={activarOn ? "boton" : "botoncp"}
              onClick={activarOn ? modificarEmpleado2 : ""}
            >
              Modificar Empleado
            </button>
            {data.aprobado !== "SI" && (
              <button className="boton" onClick={aprobarC}>
                Aprobar Colaborador
              </button>
            )}
            {data.aprobado === "SI" && (
              <button
                className={activarOn ? "boton" : "botoncp"}
                onClick={activarOn ? tipoNominaCreada : ""}
              >
                Tipos de Nominas Creadas
              </button>
            )}
            {data.aprobado === "SI" && (
              <button
                className={activarOn ? "boton" : "botoncp"}
                onClick={activarOn ? abrirVerMas : ""}
              >
                Ver Mas +
              </button>
            )}
            {data.aprobado === "SI" &&
              codigoOperativo(data.tcontratoOperativo) !== 2 && (
              <button
                className={activarOn ? "boton" : "botoncp"}
                onClick={activarOn ? imprimirContrato : ""}
              >
                Imprimir contrato
              </button>
            )}
            {data.aprobado === "SI" &&
              esContratoOperativo(data.tiponomina, data.tcontrato) &&
              tienePorTerapiaOperativo(data.tcontratoOperativo) && (
              <button
                className={activarOn ? "boton" : "botoncp"}
                onClick={activarOn ? imprimirContratoTerapia : ""}
              >
                Pago X Terapia
              </button>
            )}
            {data.aprobado === "SI" && (
              <button
                className={activarOn ? "boton" : "botoncp"}
                onClick={activarOn ? horarioNomina : ""}
              >
                Horario Nomina
              </button>
            )}
            {data.aprobado === "SI" && (
              <button
                className={activarOn ? "boton" : "botoncp"}
                onClick={activarOn ? abrirReporteIncIna : ""}
              >
                Incapacidades e Inasistencias
              </button>
            )}
            <button
              className={activarOn ? "boton" : "botoncp"}
              onClick={activarOn ? datosADM : ""}
            >
              Salir Administrativo
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(Empleados);
